import React, { useState, useEffect, useCallback } from "react";

// Room selection state for header checkboxes
// (added below in component)
import { makeAuthenticatedRequest } from "../../utils/apiRequest";
import { useAuth } from "../../contexts/authContext";

const AccommodationPopup = ({ isOpen, onClose, itineraryId }) => {
  // Track which row's document popup is open; null means none
  const [documentPopupIndex, setDocumentPopupIndex] = useState(null);
  // Store the latest POST response from accommodation API
  const [accommodationApiResponse, setAccommodationApiResponse] = useState(null);
  // Track which room types are selected (all selected by default)
  const [roomSelection, setRoomSelection] = useState({ sgl: false, dbl: false, tpl: false });

  // Add this with your other state declarations
const [loadingPrices, setLoadingPrices] = useState({}); // { rowIndex: boolean }

  // State for number of adults/children
  const [numAdults, setNumAdults] = useState(0);
  const [numChildren, setNumChildren] = useState(0);

  const [marketType, setMarketType] = useState("");

  // Add keyboard navigation state
const [focusedInput, setFocusedInput] = useState(null); // { row: number, field: string } or null

const [bookingType, setBookingType] = useState("period");
const [bookingStartDate, setBookingStartDate] = useState("");
const [bookingEndDate, setBookingEndDate] = useState("");
const [specificBookingDate, setSpecificBookingDate] = useState("");

// Add calendar popup state
const [calendarPopupOpen, setCalendarPopupOpen] = useState(null); // { rowIndex: number } or null
const [availableBookingPeriods, setAvailableBookingPeriods] = useState({}); // { hotelName_date: [periods] }

// Add this with your other state declarations
const [selectedBookingPeriods, setSelectedBookingPeriods] = useState({}); // { rowIndex: selectedEntry }





  
 // Helper to extract hotel_id for each accommodation row
const getHotelIdForRow = (acc, dayIdx) => {
  // Try to get from API response using day and hotel name
  const itineraryData = apiResponseData?.data?.[0] || apiResponseData;
  
  if (itineraryData && itineraryData.days && Array.isArray(itineraryData.days)) {
    // First, try to find checkin activity for this specific day
    const dayData = itineraryData.days[dayIdx];
    if (dayData && Array.isArray(dayData.activity)) {
      const checkin = dayData.activity.find(act => act.activity_type === 'checkin' && act.hotel_name === acc.hotel);
      if (checkin && checkin.hotel_id) return checkin.hotel_id;
    }
    
    // If no checkin found for this day, search for the hotel_id in previous days (carry forward logic)
    for (let i = dayIdx - 1; i >= 0; i--) {
      const prevDayData = itineraryData.days[i];
      if (prevDayData && Array.isArray(prevDayData.activity)) {
        const prevCheckin = prevDayData.activity.find(act => 
          act.activity_type === 'checkin' && 
          act.hotel_name === acc.hotel &&
          act.hotel_id
        );
        if (prevCheckin && prevCheckin.hotel_id) {
          console.log(`Found hotel_id for ${acc.hotel} from day ${i + 1}: ${prevCheckin.hotel_id}`);
          return prevCheckin.hotel_id;
        }
      }
    }
    
    // If still not found, search in future days
    for (let i = dayIdx + 1; i < itineraryData.days.length; i++) {
      const futureDayData = itineraryData.days[i];
      if (futureDayData && Array.isArray(futureDayData.activity)) {
        const futureCheckin = futureDayData.activity.find(act => 
          act.activity_type === 'checkin' && 
          act.hotel_name === acc.hotel &&
          act.hotel_id
        );
        if (futureCheckin && futureCheckin.hotel_id) {
          console.log(`Found hotel_id for ${acc.hotel} from future day ${i + 1}: ${futureCheckin.hotel_id}`);
          return futureCheckin.hotel_id;
        }
      }
    }
  }
  
  // Fallback: maybe in acc itself
  if (acc.hotel_id) return acc.hotel_id;
  
  // Final fallback: search in itinerary_cost data
  if (itineraryData && itineraryData.itinerary_cost && Array.isArray(itineraryData.itinerary_cost)) {
    for (const dayData of itineraryData.itinerary_cost) {
      if (dayData.accommodation && 
          dayData.accommodation.hotel_name === acc.hotel && 
          dayData.accommodation.hotel_id) {
        console.log(`Found hotel_id for ${acc.hotel} from itinerary_cost: ${dayData.accommodation.hotel_id}`);
        return dayData.accommodation.hotel_id;
      }
    }
  }
  
  console.warn(`Could not find hotel_id for ${acc.hotel} on day ${dayIdx + 1}`);
  return '';
};

  // POST selected accommodation info when room type is toggled
// POST selected accommodation info when room type is toggled
const postAccommodationSelection = async (updatedSelection) => {
  // Only post if at least one room type is selected
  if (!updatedSelection.sgl && !updatedSelection.dbl && !updatedSelection.tpl) return;
  
  try {
    // Set loading state for all rows
    const loadingState = {};
    accommodations.forEach((_, index) => {
      loadingState[index] = true;
    });
    setLoadingPrices(loadingState);

    // Prepare payload: one object per day with new format
    const payload = accommodations.map((acc, idx) => {
      const basePayload = {
        Travel_date: acc.date,
        hotel_id: getHotelIdForRow(acc, idx),
        hotel_name: acc.hotel,
        meal_plan: acc.basis,
        room_category: acc.roomCategory,
        is_booking_date: bookingType === "date",
         market_type: marketType || "All"
      };

      // Add booking information based on type
      if (bookingType === "period") {
        basePayload.booking_period = {
          booking_start: bookingStartDate || "",
          booking_end: bookingEndDate || ""
        };
      } else {
        basePayload.booking_date = specificBookingDate || "";
      }

      return basePayload;
    });

    console.log('Accommodation selection POST request body:', payload);
    
    const response = await fetch('https://automate-accommodation-14140141147.us-central1.run.app', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(payload)
    });
    
    const result = await response.json();
    setAccommodationApiResponse(result);
    console.log('Accommodation selection POST response:', result);

    // Map for occupancy type
    const occTypeMap = {
      sgl: 'single',
      dbl: 'double',
      tpl: 'triple'
    };

    // Update state with fetched prices
   // Update state with fetched prices
setAccommodations(prevAccs => prevAccs.map((acc, idx) => {
  const key = `${acc.hotel}_${acc.date}`;
  let hotelData = null;
  
  if (result[key]) {
    hotelData = result[key];
  } else {
    const foundKey = Object.keys(result).find(k => 
      k.includes(acc.hotel) && k.includes(acc.date)
    );
    if (foundKey) {
      hotelData = result[foundKey];
    }
  }
  
  let newAcc = { ...acc };
  
  if (hotelData && Array.isArray(hotelData)) {
    const matchingEntry = hotelData.find(entry => {
      const entryMealPlan = entry.adult_room_rate?.[0]?.meal_plan;
      const accBasis = acc.basis.toUpperCase().replace('/', '');
      const entryBasisNormalized = entryMealPlan?.toUpperCase().replace('/', '');
      
      return entryBasisNormalized === accBasis;
    });
    
    if (matchingEntry && matchingEntry.adult_room_rate && Array.isArray(matchingEntry.adult_room_rate)) {
      const roomRates = matchingEntry.adult_room_rate;
      
      const occupancyMap = {
        sgl: 'single',
        dbl: 'double', 
        tpl: 'triple'
      };
      
      ['sgl', 'dbl', 'tpl'].forEach(type => {
        const priceEditedKey = `${type}PriceEdited`;
        if (updatedSelection[type] && !acc[priceEditedKey]) {
          const occupancyType = occupancyMap[type];
          const rateObj = roomRates.find(r => r.room_occupancy_type === occupancyType);
          
          if (rateObj && typeof rateObj.adult_room_cost === 'number') {
            if (type === 'sgl') newAcc.sglPrice = rateObj.adult_room_cost;
            if (type === 'dbl') newAcc.dblPrice = rateObj.adult_room_cost;
            if (type === 'tpl') newAcc.tplPrice = rateObj.adult_room_cost;
          }
        }
      });
      
      // ADD THIS: Handle tax_available from API response
      if (matchingEntry.tax_available !== undefined) {
        const taxAvailable = matchingEntry.tax_available;
        
        // If tax is not available, uncheck all tax included checkboxes for this entry
        if (!taxAvailable) {
          if (!acc.sglTaxEdited) {
            newAcc.sglTaxIncluded = false;
          }
          if (!acc.dblTaxEdited) {
            newAcc.dblTaxIncluded = false;
          }
          if (!acc.tplTaxEdited) {
            newAcc.tplTaxIncluded = false;
          }
        } else {
          // Handle tax information if available (existing logic)
          if (matchingEntry.pop_up && matchingEntry.pop_up.tax_serviceCharge) {
            const taxIncluded = true;
            
            if (!acc.sglTaxEdited) {
              newAcc.sglTaxIncluded = acc.sglTaxIncluded !== undefined ? acc.sglTaxIncluded : taxIncluded;
            }
            if (!acc.dblTaxEdited) {
              newAcc.dblTaxIncluded = acc.dblTaxIncluded !== undefined ? acc.dblTaxIncluded : taxIncluded;
            }
            if (!acc.tplTaxEdited) {
              newAcc.tplTaxIncluded = acc.tplTaxIncluded !== undefined ? acc.tplTaxIncluded : taxIncluded;
            }
          } else {
            if (!acc.sglTaxEdited) {
              newAcc.sglTaxIncluded = acc.sglTaxIncluded !== undefined ? acc.sglTaxIncluded : true;
            }
            if (!acc.dblTaxEdited) {
              newAcc.dblTaxIncluded = acc.dblTaxIncluded !== undefined ? acc.dblTaxIncluded : true;
            }
            if (!acc.tplTaxEdited) {
              newAcc.tplTaxIncluded = acc.tplTaxIncluded !== undefined ? acc.tplTaxIncluded : true;
            }
          }
        }
      } else {
        // Existing fallback logic when tax_available is not present
        if (matchingEntry.pop_up && matchingEntry.pop_up.tax_serviceCharge) {
          const taxIncluded = true;
          
          if (!acc.sglTaxEdited) {
            newAcc.sglTaxIncluded = acc.sglTaxIncluded !== undefined ? acc.sglTaxIncluded : taxIncluded;
          }
          if (!acc.dblTaxEdited) {
            newAcc.dblTaxIncluded = acc.dblTaxIncluded !== undefined ? acc.dblTaxIncluded : taxIncluded;
          }
          if (!acc.tplTaxEdited) {
            newAcc.tplTaxIncluded = acc.tplTaxIncluded !== undefined ? acc.tplTaxIncluded : taxIncluded;
          }
        } else {
          if (!acc.sglTaxEdited) {
            newAcc.sglTaxIncluded = acc.sglTaxIncluded !== undefined ? acc.sglTaxIncluded : true;
          }
          if (!acc.dblTaxEdited) {
            newAcc.dblTaxIncluded = acc.dblTaxIncluded !== undefined ? acc.dblTaxIncluded : true;
          }
          if (!acc.tplTaxEdited) {
            newAcc.tplTaxIncluded = acc.tplTaxIncluded !== undefined ? acc.tplTaxIncluded : true;
          }
        }
      }
    }
  }
  
  return newAcc;
}));
    // Clear loading state after prices are updated
    setLoadingPrices({});

  } catch (err) {
    console.error('Error posting accommodation selection:', err);
    // Clear loading state on error
    setLoadingPrices({});
  }
};

const LoadingSpinner = ({ size = "w-4 h-4" }) => (
  <div className={`${size} animate-spin`}>
    <svg className="w-full h-full" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" className="opacity-25"></circle>
      <path d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" fill="currentColor"></path>
    </svg>
  </div>
);

  // Handler for header checkbox
  const handleRoomSelectionChange = (type) => {
    setRoomSelection(prev => {
      const updated = { ...prev, [type]: !prev[type] };
      // Also update in accommodations state so it gets saved
      setAccommodations(accs => accs.map((acc, idx) => idx === 0 ? { ...acc, roomSelection: updated } : acc));
      // POST selection info
      setTimeout(() => postAccommodationSelection(updated), 0);
      return updated;
    });
  }

  const { token } = useAuth();
  const [loading, setLoading] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [error, setError] = useState(null);
  const [accommodations, setAccommodations] = useState([]);
  // Store meal plan options per hotel
  const [hotelMealPlans, setHotelMealPlans] = useState({});
// Helper to get tax percentage from API response
const getTaxPercentage = () => {
  const itineraryData = apiResponseData?.data?.[0] || apiResponseData;
  if (itineraryData && itineraryData.taxes && itineraryData.taxes.length > 0) {
    return itineraryData.taxes[0].tax_percentage || 0;
  }
  return 0;
};
  const [apiResponseData, setApiResponseData] = useState(null);

  // Sample data to display initially or as fallback
const getSampleData = () => {
  return [
    {
      day: "01",
      date: "(20XX-XX-XX)",
      city: "Colombo",
      hotel: "Taj",
      roomCategory: "Superior City View",
      basis: "H/B",
      breakfast: true,
      lunch: false,
      dinner: true,
      sglPrice: 150,
      dblPrice: 200,
      tplPrice: 250,
      sglTaxIncluded: true, // Add this
      dblTaxIncluded: true, // Add this
      tplTaxIncluded: true  // Add this
    },
    {
      day: "02",
      date: "(20XX-XX-XX)",
      city: "Kandy",
      hotel: "Queens",
      roomCategory: "Deluxe Lake View",
      basis: "H/B",
      breakfast: true,
      lunch: false,
      dinner: true,
      sglPrice: 120,
      dblPrice: 180,
      tplPrice: 220,
      sglTaxIncluded: true, // Add this
      dblTaxIncluded: true, // Add this
      tplTaxIncluded: true  // Add this
    }
  ];
};
  // Fetch accommodation data from API
  const fetchAccommodations = useCallback(async () => {
    if (!token || !itineraryId) {
      setAccommodations(getSampleData());
      return;
    }
    
    console.log('AccommodationPopup: Starting to fetch accommodation data...');
    console.log('AccommodationPopup: Using itinerary ID:', itineraryId);
    
    setLoading(true);
    try {
      const response = await makeAuthenticatedRequest(
        "https://us-central1-evoq-travel-craft.cloudfunctions.net/get_itinerary_data",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ itinerary_id: itineraryId }),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const responseData = await response.json();
      console.log('AccommodationPopup: API response received:', responseData);
      
      // Store the full response data in state for later use
      setApiResponseData(responseData);
      
      // The API response has data nested inside a 'data' array
      const itineraryData = responseData.data && responseData.data[0] ? responseData.data[0] : responseData;
      console.log('AccommodationPopup: Extracted itinerary data:', itineraryData);

      // Extract number of adults and children if available
     if (itineraryData.bookingDetails) {
  setNumAdults(Number(itineraryData.bookingDetails.numAdults) || 0);
  setNumChildren(Number(itineraryData.bookingDetails.numChildren) || 0);
  
  // Add these new lines for booking information
  setBookingType(itineraryData.bookingDetails.bookingType || "period");
  setBookingStartDate(itineraryData.bookingDetails.bookingStartDate || "");
  setBookingEndDate(itineraryData.bookingDetails.bookingEndDate || "");
  setSpecificBookingDate(itineraryData.bookingDetails.specificBookingDate || "");
   setMarketType(itineraryData.bookingDetails.marketType || "");
} else {
  setNumAdults(0);
  setNumChildren(0);
  // Set default booking values
  setBookingType("period");
  setBookingStartDate("");
  setBookingEndDate("");
  setSpecificBookingDate("");
  setMarketType("");
}
      
      // Initialize formatted data array
      let formattedData = [];
      
      // First, check if we have the new data structure with days and activities
      // --- Collect meal plans for each hotel ---
      const mealPlansPerHotel = {};
      if (itineraryData.days && Array.isArray(itineraryData.days)) {
        console.log('AccommodationPopup: Found days array in itinerary data');
        
        // Process each day in the days array
        let lastCheckinActivity = null;
        itineraryData.days.forEach((dayData, idx) => {
          // Collect meal plans for each hotel in this day's activities
          if (Array.isArray(dayData.activity)) {
            dayData.activity.forEach(act => {
              if (act.hotel_name && act.mealPlan) {
                const hotel = act.hotel_name;
                // Normalize mealPlan to string and split if comma separated
                let plans = Array.isArray(act.mealPlan) ? act.mealPlan : String(act.mealPlan).split(',').map(x => x.trim());
                if (!mealPlansPerHotel[hotel]) mealPlansPerHotel[hotel] = new Set();
                plans.forEach(plan => mealPlansPerHotel[hotel].add(plan));
              }
            });
          }
          // Normalize day number to two digits string
          const dayNumber = dayData.day_number ? dayData.day_number.toString().padStart(2, '0') : (idx + 1).toString().padStart(2, '0');
          // Use calander_date if present, otherwise fallback
          const date = dayData.calander_date || dayData.date || '';
          // Get city information
          let cityName = '';
          if (dayData.city && Array.isArray(dayData.city) && dayData.city.length > 0) {
            cityName = dayData.city[0].city_name || '';
          }
          let hotel = '';
          let roomCategory = '';
          let basis = 'H/B';
          let breakfast = false;
          let lunch = false;
          let dinner = false;
          let sglPrice = 0, dblPrice = 0, tplPrice = 0;
          let sglPricePerPerson, dblPricePerPerson, tplPricePerPerson;

          // Always look for a checkin activity for this day
          let foundCheckin = false;
          if (Array.isArray(dayData.activity)) {
            for (const act of dayData.activity) {
              if (act.activity_type === 'checkin' && act.hotel_name) {
                hotel = act.hotel_name;
                roomCategory = act.roomType || '';
                basis = act.mealPlan || 'HB';
                breakfast = act.mealPlan?.toUpperCase().includes('B') || act.breakfast || false;
                lunch = act.mealPlan?.toUpperCase().includes('L') || act.lunch || false;
                dinner = act.mealPlan?.toUpperCase().includes('D') || act.dinner || false;
                // Extract price fields from checkin activity if available
                sglPricePerPerson = act.sgl_price_per_person;
                dblPricePerPerson = act.dbl_price_per_person;
                tplPricePerPerson = act.tpl_price_per_person;
                sglPrice = parseFloat(act.sgl_price) || 0;
                dblPrice = parseFloat(act.dbl_price) || 0;
                tplPrice = parseFloat(act.tpl_price) || 0;
                foundCheckin = true;
                lastCheckinActivity = {
                  hotel,
                  roomCategory,
                  basis,
                  breakfast,
                  lunch,
                  dinner,
                  sglPrice,
                  dblPrice,
                  tplPrice,
                  sglPricePerPerson,
                  dblPricePerPerson,
                  tplPricePerPerson
                };
                console.log(`AccommodationPopup: Extracted checkin hotel for day ${dayNumber}:`, hotel, roomCategory);
                break;
              }
            }
          }

          // If no checkin found, use lastCheckinActivity if available
          if (!foundCheckin && lastCheckinActivity) {
            hotel = lastCheckinActivity.hotel;
            roomCategory = lastCheckinActivity.roomCategory;
            basis = lastCheckinActivity.basis;
            breakfast = lastCheckinActivity.breakfast;
            lunch = lastCheckinActivity.lunch;
            dinner = lastCheckinActivity.dinner;
            sglPrice = lastCheckinActivity.sglPrice;
            dblPrice = lastCheckinActivity.dblPrice;
            tplPrice = lastCheckinActivity.tplPrice;
            sglPricePerPerson = lastCheckinActivity.sglPricePerPerson;
            dblPricePerPerson = lastCheckinActivity.dblPricePerPerson;
            tplPricePerPerson = lastCheckinActivity.tplPricePerPerson;
            console.log(`AccommodationPopup: Carrying forward previous checkin hotel for day ${dayNumber}:`, hotel, roomCategory);
          } else if (!foundCheckin) {
            console.log(`AccommodationPopup: No checkin hotel found for day ${dayNumber} and no previous checkin to carry forward.`);
          }

        
// Always override prices and tax flags from itinerary_cost if present for this day
let sglTaxIncluded = true, dblTaxIncluded = true, tplTaxIncluded = true;
let sglBase = sglPrice, dblBase = dblPrice, tplBase = tplPrice;

// Declare costEntry outside the if block
let costEntry;

if (itineraryData.itinerary_cost && Array.isArray(itineraryData.itinerary_cost)) {
  costEntry = itineraryData.itinerary_cost.find(cost => {
    const costDay = (cost.day || '').replace('Day ', '').padStart(2, '0');
    return costDay === dayNumber && cost.city === cityName; // Also match city
  });
  
  if (costEntry && costEntry.accommodation) {
    const acc = costEntry.accommodation;
    
    // Update hotel details from accommodation data
    if (acc.hotel_name) hotel = acc.hotel_name;
    if (acc.basis) basis = acc.basis;
    if (acc.roomType || acc.room_category) roomCategory = acc.roomType || acc.room_category;
    
    // Extract meal plan details
    if (acc.basis) {
      const basisUpper = acc.basis.toUpperCase();
      breakfast = basisUpper.includes('B');
      lunch = basisUpper.includes('L');
      dinner = basisUpper.includes('D');
    }
    
    // Use per-person price fields if present
    sglPrice = (acc.sgl_price_per_person !== undefined && acc.sgl_price_per_person !== null && acc.sgl_price_per_person !== "")
      ? parseFloat(acc.sgl_price_per_person)
      : (parseFloat(acc.sgl_price) || 0);
    dblPrice = (acc.dbl_price_per_person !== undefined && acc.dbl_price_per_person !== null && acc.dbl_price_per_person !== "")
      ? parseFloat(acc.dbl_price_per_person)
      : (parseFloat(acc.dbl_price) || 0);
    tplPrice = (acc.tpl_price_per_person !== undefined && acc.tpl_price_per_person !== null && acc.tpl_price_per_person !== "")
      ? parseFloat(acc.tpl_price_per_person)
      : (parseFloat(acc.tpl_price) || 0);
    
    sglTaxIncluded = typeof acc.sglTaxIncluded === 'boolean' ? acc.sglTaxIncluded : true;
    dblTaxIncluded = typeof acc.dblTaxIncluded === 'boolean' ? acc.dblTaxIncluded : true;
    tplTaxIncluded = typeof acc.tplTaxIncluded === 'boolean' ? acc.tplTaxIncluded : true;
    
    sglBase = acc.sglBase !== undefined ? parseFloat(acc.sglBase) : sglPrice;
    dblBase = acc.dblBase !== undefined ? parseFloat(acc.dblBase) : dblPrice;
    tplBase = acc.tplBase !== undefined ? parseFloat(acc.tplBase) : tplBase;
    
    console.log(`AccommodationPopup: Updated accommodation details for day ${dayNumber}:`, {
      hotel, roomCategory, basis, sglPrice, dblPrice, tplPrice
    });
  }
}

formattedData.push({
  day: dayNumber,
  date: date,
  city: cityName,
  hotel: hotel || 'No Hotel Selected',
  roomCategory: roomCategory || 'Standard',
  basis: basis || 'H/B',
  breakfast: breakfast,
  lunch: lunch,
  dinner: dinner,
  sglPrice: sglPrice,
  dblPrice: dblPrice,
  tplPrice: tplPrice,
  sglTaxIncluded,
  dblTaxIncluded,
  tplTaxIncluded,
  sglBase,
  dblBase,
  tplBase,
  // Add With Bed/Without Bed fields from costEntry if present
  sglExtra1: costEntry && costEntry.accommodation && costEntry.accommodation.sgl_with_bed_price_per_person !== undefined
    ? String(costEntry.accommodation.sgl_with_bed_price_per_person)
    : '',
  sglExtra2: costEntry && costEntry.accommodation && costEntry.accommodation.sgl_without_bed_price_per_person !== undefined
    ? String(costEntry.accommodation.sgl_without_bed_price_per_person)
    : '',
  dblExtra1: costEntry && costEntry.accommodation && costEntry.accommodation.dbl_with_bed_price_per_person !== undefined
    ? String(costEntry.accommodation.dbl_with_bed_price_per_person)
    : '',
  dblExtra2: costEntry && costEntry.accommodation && costEntry.accommodation.dbl_without_bed_price_per_person !== undefined
    ? String(costEntry.accommodation.dbl_without_bed_price_per_person)
    : '',
  tplExtra1: costEntry && costEntry.accommodation && costEntry.accommodation.tpl_with_bed_price_per_person !== undefined
    ? String(costEntry.accommodation.tpl_with_bed_price_per_person)
    : '',
  tplExtra2: costEntry && costEntry.accommodation && costEntry.accommodation.tpl_without_bed_price_per_person !== undefined
    ? String(costEntry.accommodation.tpl_without_bed_price_per_person)
    : '',
  // Copy pop_up_details from costEntry if present
  pop_up_details: (costEntry && costEntry.accommodation && costEntry.accommodation.pop_up_details)
    ? costEntry.accommodation.pop_up_details
    : undefined,
    
  // ADD THIS LINE to restore saved booking periods:
  all_available_booking_periods: (costEntry && costEntry.accommodation && costEntry.accommodation.all_available_booking_periods)
    ? costEntry.accommodation.all_available_booking_periods
    : null
});
        });
      }
      
      // Only use itinerary_cost as a fallback if days extraction yields no valid data
   // Only use itinerary_cost as a fallback if days extraction yields no valid data
// Only use itinerary_cost as a fallback if days extraction yields no valid data
if (
  (!formattedData || formattedData.length === 0 || 
   formattedData.every(d => !d.hotel || d.hotel === 'No Hotel Selected')) &&
  itineraryData.itinerary_cost && Array.isArray(itineraryData.itinerary_cost)
) { 
  console.log('AccommodationPopup: Using itinerary_cost as fallback data source');
  
  formattedData = itineraryData.itinerary_cost
    .filter(dayData => dayData.accommodation && dayData.accommodation.hotel_name) // Only include days with accommodation
    .map(dayData => {
      const dayNumber = dayData.day?.replace('Day ', '') || '01';
      const date = dayData.calendar_date || dayData.date || '(20XX-XX-XX)';
      const city = dayData.city || '';
      const acc = dayData.accommodation || {};
      const taxPercentage = getTaxPercentage();
      
      let sglTaxIncluded = typeof acc.sglTaxIncluded === 'boolean' ? acc.sglTaxIncluded : true;
      let dblTaxIncluded = typeof acc.dblTaxIncluded === 'boolean' ? acc.dblTaxIncluded : true;
      let tplTaxIncluded = typeof acc.tplTaxIncluded === 'boolean' ? acc.tplTaxIncluded : true;
      
      let sglBase = acc.sglBase !== undefined ? parseFloat(acc.sglBase) : 
        (parseFloat(acc.sgl_price_per_person) || parseFloat(acc.sgl_price) || 0);
      let dblBase = acc.dblBase !== undefined ? parseFloat(acc.dblBase) : 
        (parseFloat(acc.dbl_price_per_person) || parseFloat(acc.dbl_price) || 0);
      let tplBase = acc.tplBase !== undefined ? parseFloat(acc.tplBase) : 
        (parseFloat(acc.tpl_price_per_person) || parseFloat(acc.tpl_price) || 0);
      
      // Calculate base from price if tax is included
      if (sglTaxIncluded && sglBase === 0 && parseFloat(acc.sgl_price) > 0) {
        sglBase = parseFloat(acc.sgl_price) / (1 + taxPercentage / 100);
      }
      if (dblTaxIncluded && dblBase === 0 && parseFloat(acc.dbl_price) > 0) {
        dblBase = parseFloat(acc.dbl_price) / (1 + taxPercentage / 100);
      }
      if (tplTaxIncluded && tplBase === 0 && parseFloat(acc.tpl_price) > 0) {
        tplBase = parseFloat(acc.tpl_price) / (1 + taxPercentage / 100);
      }
      
      return {
        isApiHotel: false,
        day: dayNumber.padStart(2, '0'),
        date,
        city,
        hotel: acc.hotel_name || 'Unknown Hotel',
        roomCategory: acc.roomType || acc.room_category || 'Standard',
        basis: acc.basis || 'H/B',
        breakfast: (acc.basis || '').toUpperCase().includes('B'),
        lunch: (acc.basis || '').toUpperCase().includes('L'),
        dinner: (acc.basis || '').toUpperCase().includes('D'),
        sglBase,
        sglPrice: (acc.sgl_price_per_person !== undefined && acc.sgl_price_per_person !== null && acc.sgl_price_per_person !== "") 
          ? parseFloat(acc.sgl_price_per_person) 
          : (parseFloat(acc.sgl_price) || 0),
        sglTaxIncluded,
        dblBase,
        dblPrice: (acc.dbl_price_per_person !== undefined && acc.dbl_price_per_person !== null && acc.dbl_price_per_person !== "") 
          ? parseFloat(acc.dbl_price_per_person) 
          : (parseFloat(acc.dbl_price) || 0),
        dblTaxIncluded,
        tplBase,
        tplPrice: (acc.tpl_price_per_person !== undefined && acc.tpl_price_per_person !== null && acc.tpl_price_per_person !== "") 
          ? parseFloat(acc.tpl_price_per_person) 
          : (parseFloat(acc.tpl_price) || 0),
        tplTaxIncluded,
        // Restore With Bed/Without Bed per person values
        sglExtra1: acc.sgl_with_bed_price_per_person !== undefined ? String(acc.sgl_with_bed_price_per_person) : '',
        sglExtra2: acc.sgl_without_bed_price_per_person !== undefined ? String(acc.sgl_without_bed_price_per_person) : '',
        dblExtra1: acc.dbl_with_bed_price_per_person !== undefined ? String(acc.dbl_with_bed_price_per_person) : '',
        dblExtra2: acc.dbl_without_bed_price_per_person !== undefined ? String(acc.dbl_without_bed_price_per_person) : '',
        tplExtra1: acc.tpl_with_bed_price_per_person !== undefined ? String(acc.tpl_with_bed_price_per_person) : '',
        tplExtra2: acc.tpl_without_bed_price_per_person !== undefined ? String(acc.tpl_without_bed_price_per_person) : '',
        // Restore roomSelection if present
        roomSelection: acc.roomSelection ? acc.roomSelection : undefined,
        // Copy pop_up_details
        pop_up_details: acc.pop_up_details,

          all_available_booking_periods: acc.all_available_booking_periods || null
      };
    });
}
      
      // Only use sample data if we have no valid data from API
      if (!formattedData || formattedData.length === 0) {
        console.log('AccommodationPopup: No valid accommodation data found in any format');
        formattedData = getSampleData().map(acc => ({ ...acc, isApiHotel: false }));
      }
      
     console.log('AccommodationPopup: Final formatted accommodation data:', formattedData);
console.log('AccommodationPopup: Sample accommodation entry:', formattedData[0]);

// Remove the last day from the accommodation table
if (formattedData.length > 0) {
  formattedData = formattedData.slice(0, -1);
  console.log('AccommodationPopup: After removing last day:', formattedData.length, 'entries');
}
      // Mark rows as API-fetched if accommodationApiResponse exists and has data for this hotel/date
if (accommodationApiResponse) {
  formattedData = formattedData.map(acc => {
    const key = `${acc.hotel}_${acc.date}`;
    return {
      ...acc,
      isApiHotel: !!accommodationApiResponse[key] // true ONLY if present in API response
    };
  });
} else {
  // If no API response, mark all as NOT API
  formattedData = formattedData.map(acc => ({
    ...acc,
    isApiHotel: false
  }));
}

// Add this section in fetchAccommodations, after formattedData is populated but before setAccommodations(formattedData)

// Restore selected booking periods from saved data
const restoredSelectedBookingPeriods = {};
formattedData.forEach((acc, index) => {
  // Check if this accommodation has a selected booking period saved
  let selectedPeriodData = null;
  
  // First check in costEntry if it exists
  if (itineraryData.itinerary_cost && Array.isArray(itineraryData.itinerary_cost)) {
    const dayString = acc.day.startsWith('Day ') ? acc.day : `Day ${acc.day.toString().padStart(2, '0')}`;
    const costEntry = itineraryData.itinerary_cost.find(cost => cost.day === dayString);
    
    if (costEntry && costEntry.accommodation && costEntry.accommodation.selected_booking_period) {
      selectedPeriodData = costEntry.accommodation.selected_booking_period.full_booking_entry;
    }
  }
  
  // Also check in days array for selected_booking_period
  if (!selectedPeriodData && itineraryData.days && Array.isArray(itineraryData.days)) {
    const dayData = itineraryData.days.find(day => 
      day.day_number === acc.day || day.day_number === parseInt(acc.day, 10).toString()
    );
    
    if (dayData && Array.isArray(dayData.activity)) {
      const checkinActivity = dayData.activity.find(act => 
        act.activity_type === 'checkin' && act.selected_booking_period
      );
      
      if (checkinActivity && checkinActivity.selected_booking_period) {
        selectedPeriodData = checkinActivity.selected_booking_period.full_booking_entry;
      }
    }
  }
  
  // If we found selected booking period data, restore it
  if (selectedPeriodData) {
    restoredSelectedBookingPeriods[index] = selectedPeriodData;
    console.log(`Restored selected booking period for day ${acc.day}:`, selectedPeriodData);
  }
});

// Set the restored selected booking periods
setSelectedBookingPeriods(restoredSelectedBookingPeriods);
console.log('Restored selected booking periods:', restoredSelectedBookingPeriods);
setAccommodations(formattedData);
      // DEBUG: Log accommodations after mapping
      console.log('AccommodationPopup: accommodations after mapping:', formattedData);

      
      // Convert mealPlansPerHotel Sets to arrays for state
      const mealPlansObj = {};
      Object.entries(mealPlansPerHotel).forEach(([hotel, setVal]) => {
        mealPlansObj[hotel] = Array.from(setVal);
      });
      setHotelMealPlans(mealPlansObj);
// Restore room selection from data if available (per day)
if (formattedData.length > 0 && formattedData[0].roomSelection) {
  setRoomSelection(formattedData[0].roomSelection);
} else {
  // Fallback: auto-detect based on prices
  setRoomSelection({
    sgl: formattedData.some(acc => acc.sglPrice > 0),
    dbl: formattedData.some(acc => acc.dblPrice > 0),
    tpl: formattedData.some(acc => acc.tplPrice > 0),
  });
}
    } catch (err) {
      console.error('AccommodationPopup: Error fetching accommodation data:', err.message);
      setError(err.message);
      setAccommodations(getSampleData());
    } finally {
      console.log('AccommodationPopup: Accommodation data fetch completed');
      setLoading(false);
    }
  }, [token, itineraryId]);

  // Load accommodation data when component mounts and isOpen changes
 // Add this useEffect if booking information isn't being passed from parent
// Load accommodation data when component mounts and isOpen changes
useEffect(() => {
  if (isOpen && itineraryId) {
    fetchAccommodations();
  }
}, [isOpen, itineraryId, fetchAccommodations]);


const hasBookingPeriods = (acc, rowIndex) => {
  console.log(`Checking booking periods for ${acc.hotel} (row ${rowIndex})`);
  console.log('accommodationApiResponse available:', !!accommodationApiResponse);
  console.log('acc.all_available_booking_periods:', acc.all_available_booking_periods);

  if (acc.all_available_booking_periods) {
    console.log('Number of booking periods in saved data:', acc.all_available_booking_periods.length);
  }
  
  // First check accommodationApiResponse (fresh API data)
  if (accommodationApiResponse) {
    const possibleKeys = [
      `${acc.hotel}_${acc.date}`,
      `Date_${rowIndex + 1}_${acc.hotel}_${acc.date}`,
      `Date_${rowIndex + 1}_${acc.hotel}_${acc.date} 00:00:00`,
      `Date_${rowIndex + 1}_${acc.hotel}_${acc.date.split(' ')[0]} 00:00:00`,
      `Date_${rowIndex + 1}_${acc.hotel}_${acc.date.split('T')[0]} 00:00:00`,
      ...Object.keys(accommodationApiResponse).filter(key => 
        key.includes(acc.hotel) && (
          key.includes(acc.date) || 
          key.includes(acc.date.split(' ')[0]) ||
          key.includes(acc.date.split('T')[0])
        )
      )
    ];
    
    console.log('Trying API response keys:', possibleKeys);
    console.log('Available API keys:', Object.keys(accommodationApiResponse));
    
    for (const key of possibleKeys) {
      const hotelData = accommodationApiResponse[key];
      
      if (hotelData && Array.isArray(hotelData) && hotelData.length > 0) {
        console.log(`API: Found ${hotelData.length} booking periods for ${acc.hotel}`);
        return true; // Return true if any booking periods exist
      }
    }
  }
  
  // Fallback: check saved data for booking periods
  if (acc.all_available_booking_periods && Array.isArray(acc.all_available_booking_periods) && acc.all_available_booking_periods.length > 0) {
    console.log(`Saved data: Found ${acc.all_available_booking_periods.length} booking periods for ${acc.hotel}`);
    return true; // Return true if any booking periods exist
  }
  
  console.log(`No booking periods found for ${acc.hotel}`);
  return false;
};

// Temporary function for testing - replace hasMultipleBookingPeriods with this


// Handle booking period selection
// Handle booking period selection
const handleBookingPeriodSelect = (rowIndex, selectedEntry) => {
  const updatedAccommodations = [...accommodations];
  const acc = updatedAccommodations[rowIndex];
  
  if (selectedEntry && selectedEntry.adult_room_rate && Array.isArray(selectedEntry.adult_room_rate)) {
    const roomRates = selectedEntry.adult_room_rate;
    const occupancyMap = { sgl: 'single', dbl: 'double', tpl: 'triple' };
    
    // Update prices based on current meal plan
    ['sgl', 'dbl', 'tpl'].forEach(type => {
      const priceEditedKey = `${type}PriceEdited`;
      if (roomSelection[type] && !acc[priceEditedKey]) {
        const occupancyType = occupancyMap[type];
        const rateObj = roomRates.find(r => r.room_occupancy_type === occupancyType);
        
        if (rateObj && typeof rateObj.adult_room_cost === 'number') {
          if (type === 'sgl') acc.sglPrice = rateObj.adult_room_cost;
          if (type === 'dbl') acc.dblPrice = rateObj.adult_room_cost;
          if (type === 'tpl') acc.tplPrice = rateObj.adult_room_cost;
        }
      }
    });
    
    // Update pop_up_details if available
    if (selectedEntry.pop_up) {
      acc.pop_up_details = selectedEntry.pop_up;
    }
  }
  
  // Store the selected booking period entry for this row
  setSelectedBookingPeriods(prev => ({
    ...prev,
    [rowIndex]: selectedEntry
  }));
  
  setAccommodations(updatedAccommodations);
  setCalendarPopupOpen(null);
};

// Calendar popup for booking periods
// Calendar popup for booking periods
// Replace the existing CalendarPopup component with this modified version:

const CalendarPopup = ({ rowIndex, onClose }) => {
  if (rowIndex === null || !accommodations[rowIndex]) return null;
  
  const acc = accommodations[rowIndex];
  let hotelData = null;
  
  console.log(`CalendarPopup for ${acc.hotel}, row ${rowIndex}`);
  
  // First try to get from accommodationApiResponse
  if (accommodationApiResponse) {
    const possibleKeys = [
      `${acc.hotel}_${acc.date}`,
      `Date_${rowIndex + 1}_${acc.hotel}_${acc.date}`,
      `Date_${rowIndex + 1}_${acc.hotel}_${acc.date} 00:00:00`,
      `Date_${rowIndex + 1}_${acc.hotel}_${acc.date.split(' ')[0]} 00:00:00`,
      `Date_${rowIndex + 1}_${acc.hotel}_${acc.date.split('T')[0]} 00:00:00`,
      ...Object.keys(accommodationApiResponse).filter(key => 
        key.includes(acc.hotel) && (
          key.includes(acc.date) || 
          key.includes(acc.date.split(' ')[0]) ||
          key.includes(acc.date.split('T')[0])
        )
      )
    ];
    
    for (const key of possibleKeys) {
      if (accommodationApiResponse[key]) {
        hotelData = accommodationApiResponse[key];
        console.log('Calendar popup found data with key:', key);
        break;
      }
    }
  }
  
  // Fallback to saved booking periods data
  if (!hotelData && acc.all_available_booking_periods) {
    hotelData = acc.all_available_booking_periods;
    console.log('Calendar popup using saved booking periods data:', hotelData.length, 'periods');
  }
  
  if (!hotelData || !Array.isArray(hotelData)) {
    console.log('No hotel data found for calendar popup');
    return null;
  }

  // NEW: Function to find matching booking period based on current prices
  const findMatchingBookingPeriod = () => {
    const currentSglPrice = parseFloat(acc.sglPrice) || 0;
    const currentDblPrice = parseFloat(acc.dblPrice) || 0;
    const currentTplPrice = parseFloat(acc.tplPrice) || 0;
    const currentBasis = acc.basis;
    
    console.log('Looking for booking period matching:', {
      sgl: currentSglPrice,
      dbl: currentDblPrice, 
      tpl: currentTplPrice,
      basis: currentBasis
    });

    // Find entry that matches current prices and meal plan
    const matchingEntry = hotelData.find(entry => {
      if (!entry.adult_room_rate || !Array.isArray(entry.adult_room_rate)) return false;
      
      // Check meal plan match
      const entryMealPlan = entry.adult_room_rate[0]?.meal_plan;
      const entryBasisNormalized = entryMealPlan?.toUpperCase().replace('/', '');
      const accBasisNormalized = currentBasis.toUpperCase().replace('/', '');
      
      if (entryBasisNormalized !== accBasisNormalized) return false;
      
      // Check if any room rates match current prices
      const roomRates = entry.adult_room_rate;
      const sglRate = roomRates.find(r => r.room_occupancy_type === 'single');
      const dblRate = roomRates.find(r => r.room_occupancy_type === 'double');
      const tplRate = roomRates.find(r => r.room_occupancy_type === 'triple');
      
      // Check if at least one selected room type matches
      let hasMatch = false;
      
      if (roomSelection.sgl && sglRate && Math.abs((sglRate.adult_room_cost || 0) - currentSglPrice) < 0.01) {
        hasMatch = true;
      }
      if (roomSelection.dbl && dblRate && Math.abs((dblRate.adult_room_cost || 0) - currentDblPrice) < 0.01) {
        hasMatch = true;
      }
      if (roomSelection.tpl && tplRate && Math.abs((tplRate.adult_room_cost || 0) - currentTplPrice) < 0.01) {
        hasMatch = true;
      }
      
      return hasMatch;
    });
    
    if (matchingEntry) {
      console.log('Found matching booking period:', matchingEntry.booking_period);
      return matchingEntry;
    }
    
    console.log('No matching booking period found');
    return null;
  };

  // NEW: Get preselected entry
  const preselectedEntry = findMatchingBookingPeriod();
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg p-6 max-w-md w-full relative border border-blue-300 max-h-[60vh] overflow-y-auto">
        <button
          className="absolute top-2 right-2 text-blue-500 hover:text-blue-700"
          onClick={onClose}
          aria-label="Close"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        
        <h3 className="text-lg font-semibold text-blue-800 mb-4">Select Booking Period</h3>
        <p className="text-sm text-gray-600 mb-4">Hotel: {acc.hotel}</p>
        
        <div className="space-y-3">
          {hotelData.map((entry, index) => {
            if (!entry.booking_period) return null;
            
            const { booking_start, booking_end } = entry.booking_period;
            const singleRate = entry.adult_room_rate?.find(r => r.room_occupancy_type === 'single');
            const doubleRate = entry.adult_room_rate?.find(r => r.room_occupancy_type === 'double');
            const tripleRate = entry.adult_room_rate?.find(r => r.room_occupancy_type === 'triple');
            
            // NEW: Check if this entry is preselected
            const isPreselected = preselectedEntry && 
              preselectedEntry.booking_period?.booking_start === booking_start &&
              preselectedEntry.booking_period?.booking_end === booking_end;
            
            return (
              <div
                key={index}
                className={`border rounded-lg p-3 cursor-pointer transition-colors ${
                  isPreselected 
                    ? 'border-blue-500 bg-blue-100 ring-2 ring-blue-300' // NEW: Highlight preselected
                    : 'border-blue-200 hover:bg-blue-50'
                }`}
                onClick={() => handleBookingPeriodSelect(rowIndex, entry)}
              >
                <div className="flex justify-between items-start mb-2">
                  <div>
                    <div className={`font-medium ${isPreselected ? 'text-blue-900' : 'text-blue-800'}`}>
                      {booking_start} to {booking_end}
                      {/* NEW: Add indicator for preselected */}
                      {isPreselected && (
                        <span className="ml-2 text-xs bg-blue-600 text-white px-2 py-0.5 rounded">
                          Current
                        </span>
                      )}
                    </div>
                    <div className="text-sm text-gray-600">
                      Meal Plan: {entry.adult_room_rate?.[0]?.meal_plan || 'N/A'}
                    </div>
                  </div>
                </div>
                
                <div className="grid grid-cols-3 gap-2 text-xs">
                  {singleRate && (
                    <div className="text-center">
                      <div className="font-medium">SGL</div>
                      <div>${singleRate.adult_room_cost}</div>
                    </div>
                  )}
                  {doubleRate && (
                    <div className="text-center">
                      <div className="font-medium">DBL</div>
                      <div>${doubleRate.adult_room_cost}</div>
                    </div>
                  )}
                  {tripleRate && (
                    <div className="text-center">
                      <div className="font-medium">TPL</div>
                      <div>${tripleRate.adult_room_cost}</div>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
        
        {/* NEW: Show message if preselected entry found */}
        {preselectedEntry && (
          <div className="mt-4 text-sm text-blue-700 bg-blue-50 p-2 rounded">
            <strong>Current period highlighted:</strong> This matches your current room rates and meal plan.
          </div>
        )}
      </div>
    </div>
  );
};


  const handleKeyNavigation = (e, currentRow, currentField) => {
  if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
    e.preventDefault();
    
    // Define the order of navigable fields
    const fields = [];
    if (roomSelection.sgl) {
      fields.push('sglPrice', 'sglExtra1', 'sglExtra2');
    }
    if (roomSelection.dbl) {
      fields.push('dblPrice', 'dblExtra1', 'dblExtra2');
    }
    if (roomSelection.tpl) {
      fields.push('tplPrice', 'tplExtra1', 'tplExtra2');
    }
    
    const currentFieldIndex = fields.indexOf(currentField);
    let nextRow = currentRow;
    let nextField = currentField;
    
    if (e.key === 'ArrowUp') {
      if (currentRow > 0) {
        nextRow = currentRow - 1;
      } else if (currentFieldIndex > 0) {
        nextField = fields[currentFieldIndex - 1];
        nextRow = accommodations.length - 1;
      }
    } else if (e.key === 'ArrowDown') {
      if (currentRow < accommodations.length - 1) {
        nextRow = currentRow + 1;
      } else if (currentFieldIndex < fields.length - 1) {
        nextField = fields[currentFieldIndex + 1];
        nextRow = 0;
      }
    }
    
    // Focus the next input
    setFocusedInput({ row: nextRow, field: nextField });
    setTimeout(() => {
      const nextInput = document.querySelector(`input[data-row="${nextRow}"][data-field="${nextField}"]`);
      if (nextInput) {
        nextInput.focus();
        nextInput.select();
      }
    }, 0);
  }
};

  // Format numbers to 2 decimal places with safety check
  const formatCurrency = (value) => {
    // Ensure value is a number and handle null/undefined
    if (value === null || value === undefined || isNaN(value)) {
      return "";
    }
    const numValue = parseFloat(value);
    return isNaN(numValue) ? "" : numValue.toFixed(2);
  };

  // Handlers for editing accommodation details
 const handleHotelChange = (index, newHotel) => {
  const updatedAccommodations = [...accommodations];
  updatedAccommodations[index].hotel = newHotel;
  setAccommodations(updatedAccommodations);
  // Refetch data for new hotel selection with updated endpoint
  setTimeout(() => postAccommodationSelection(roomSelection), 0);
};

  const handleBasisChange = (index, newBasis) => {
    const updatedAccommodations = [...accommodations];
    updatedAccommodations[index].basis = newBasis;
    setAccommodations(updatedAccommodations);
  };

const handleSglPriceChange = (index, newPrice) => {
  const updatedAccommodations = [...accommodations];
  const acc = updatedAccommodations[index];
  const inputValue = parseFloat(newPrice) || 0;
  
  // If tax is included by default, treat input as final price and store the original value
  if (acc.sglTaxIncluded) {
    acc.sglPrice = inputValue.toFixed(2);
    // Calculate and store base by removing tax, but keep more precision
    acc.sglBase = inputValue / (1 + getTaxPercentage() / 100);
  } else {
    // Tax not included, treat input as base price
    acc.sglBase = inputValue;
    acc.sglPrice = inputValue.toFixed(2);
  }
  
  acc.sglPriceEdited = true;
  setAccommodations(updatedAccommodations);
};

 const handleSglTaxToggle = (index) => {
  const updatedAccommodations = [...accommodations];
  const acc = updatedAccommodations[index];
  const taxPercentage = getTaxPercentage();
  
  // Get current price value (what user sees)
  const currentPrice = parseFloat(acc.sglPrice) || 0;
  let sglExtra1 = parseFloat(acc.sglExtra1) || 0;
  let sglExtra2 = parseFloat(acc.sglExtra2) || 0;
  
  if (acc.sglTaxIncluded) {
    // Currently tax included, user wants to exclude tax
    acc.sglTaxIncluded = false;
    // Remove tax from current price to get base price
    const basePrice = currentPrice / (1 + taxPercentage / 100);
    acc.sglBase = basePrice;
    acc.sglPrice = basePrice.toFixed(2);
    // Also remove tax from extra fields
    acc.sglExtra1 = (sglExtra1 / (1 + taxPercentage / 100)).toFixed(2);
    acc.sglExtra2 = (sglExtra2 / (1 + taxPercentage / 100)).toFixed(2);
  } else {
    // Currently tax excluded, user wants to include tax
    acc.sglTaxIncluded = true;
    // Use the stored base price if available, otherwise calculate from current price
    const basePrice = acc.sglBase || currentPrice;
    const priceWithTax = basePrice * (1 + taxPercentage / 100);
    acc.sglPrice = priceWithTax.toFixed(2);
    // Also add tax to extra fields
    acc.sglExtra1 = (sglExtra1 * (1 + taxPercentage / 100)).toFixed(2);
    acc.sglExtra2 = (sglExtra2 * (1 + taxPercentage / 100)).toFixed(2);
  }
  
  acc.sglTaxEdited = true;
  setAccommodations(updatedAccommodations);
};
const handleDblPriceChange = (index, newPrice) => {
  const updatedAccommodations = [...accommodations];
  const acc = updatedAccommodations[index];
  const inputValue = parseFloat(newPrice) || 0;
  
  if (acc.dblTaxIncluded) {
    acc.dblPrice = inputValue.toFixed(2);
    acc.dblBase = inputValue / (1 + getTaxPercentage() / 100);
  } else {
    acc.dblBase = inputValue;
    acc.dblPrice = inputValue.toFixed(2);
  }
  
  acc.dblPriceEdited = true;
  setAccommodations(updatedAccommodations);
};

  const handleDblTaxToggle = (index) => {
  const updatedAccommodations = [...accommodations];
  const acc = updatedAccommodations[index];
  const taxPercentage = getTaxPercentage();
  
  // Get current price value (what user sees)
  const currentPrice = parseFloat(acc.dblPrice) || 0;
  let dblExtra1 = parseFloat(acc.dblExtra1) || 0;
  let dblExtra2 = parseFloat(acc.dblExtra2) || 0;
  
  if (acc.dblTaxIncluded) {
    // Currently tax included, user wants to exclude tax
    acc.dblTaxIncluded = false;
    // Remove tax from current price to get base price
    const basePrice = currentPrice / (1 + taxPercentage / 100);
    acc.dblBase = basePrice;
    acc.dblPrice = basePrice.toFixed(2);
    // Also remove tax from extra fields
    acc.dblExtra1 = (dblExtra1 / (1 + taxPercentage / 100)).toFixed(2);
    acc.dblExtra2 = (dblExtra2 / (1 + taxPercentage / 100)).toFixed(2);
  } else {
    // Currently tax excluded, user wants to include tax
    acc.dblTaxIncluded = true;
    // Use the stored base price if available, otherwise calculate from current price
    const basePrice = acc.dblBase || currentPrice;
    const priceWithTax = basePrice * (1 + taxPercentage / 100);
    acc.dblPrice = priceWithTax.toFixed(2);
    // Also add tax to extra fields
    acc.dblExtra1 = (dblExtra1 * (1 + taxPercentage / 100)).toFixed(2);
    acc.dblExtra2 = (dblExtra2 * (1 + taxPercentage / 100)).toFixed(2);
  }
  
  acc.dblTaxEdited = true;
  setAccommodations(updatedAccommodations);
};const handleTplPriceChange = (index, newPrice) => {
  const updatedAccommodations = [...accommodations];
  const acc = updatedAccommodations[index];
  const inputValue = parseFloat(newPrice) || 0;
  
  // If tax is included by default, treat input as final price and store the original value
  if (acc.tplTaxIncluded) {
    acc.tplPrice = inputValue.toFixed(2);
    // Calculate and store base by removing tax, but keep more precision
    acc.tplBase = inputValue / (1 + getTaxPercentage() / 100);
  } else {
    // Tax not included, treat input as base price
    acc.tplBase = inputValue;
    acc.tplPrice = inputValue.toFixed(2);
  }
  
  acc.tplPriceEdited = true;
  setAccommodations(updatedAccommodations);
};

  const handleTplTaxToggle = (index) => {
  const updatedAccommodations = [...accommodations];
  const acc = updatedAccommodations[index];
  const taxPercentage = getTaxPercentage();
  
  // Get current price value (what user sees)
  const currentPrice = parseFloat(acc.tplPrice) || 0;
  let tplExtra1 = parseFloat(acc.tplExtra1) || 0;
  let tplExtra2 = parseFloat(acc.tplExtra2) || 0;
  
  if (acc.tplTaxIncluded) {
    // Currently tax included, user wants to exclude tax
    acc.tplTaxIncluded = false;
    // Remove tax from current price to get base price
    const basePrice = currentPrice / (1 + taxPercentage / 100);
    acc.tplBase = basePrice;
    acc.tplPrice = basePrice.toFixed(2);
    // Also remove tax from extra fields
    acc.tplExtra1 = (tplExtra1 / (1 + taxPercentage / 100)).toFixed(2);
    acc.tplExtra2 = (tplExtra2 / (1 + taxPercentage / 100)).toFixed(2);
  } else {
    // Currently tax excluded, user wants to include tax
    acc.tplTaxIncluded = true;
    // Use the stored base price if available, otherwise calculate from current price
    const basePrice = acc.tplBase || currentPrice;
    const priceWithTax = basePrice * (1 + taxPercentage / 100);
    acc.tplPrice = priceWithTax.toFixed(2);
    // Also add tax to extra fields
    acc.tplExtra1 = (tplExtra1 * (1 + taxPercentage / 100)).toFixed(2);
    acc.tplExtra2 = (tplExtra2 * (1 + taxPercentage / 100)).toFixed(2);
  }
  
  acc.tplTaxEdited = true;
  setAccommodations(updatedAccommodations);
};

  // Save changes to API
  // Save changes to API
const saveChanges = async () => {
  if (!token || !itineraryId) {
    onClose();
    return;
  }
  
  setUpdating(true);
  try {
    console.log('AccommodationPopup: Saving updated accommodation data:', accommodations);
    
    // Get the full itinerary data from the API response to preserve other data
    const itineraryData = apiResponseData?.data?.[0] || apiResponseData || {};
    
    // Create a deep copy to avoid mutating the original
    const updatedItineraryData = JSON.parse(JSON.stringify(itineraryData));
    
    // Check if we have the new data structure with days array
    if (updatedItineraryData.days && Array.isArray(updatedItineraryData.days)) {
      console.log('AccommodationPopup: Updating days array structure');
      
      // Update each day's hotel information
      accommodations.forEach((accommodation, index) => {
        const dayNumber = accommodation.day;
        
        // Find the corresponding day in the days array
        const dayIndex = updatedItineraryData.days.findIndex(day => 
          day.day_number === dayNumber || day.day_number === parseInt(dayNumber, 10).toString()
        );
        
        if (dayIndex !== -1) {
          const day = updatedItineraryData.days[dayIndex];
          
          // Ensure activity array exists
          if (!day.activity) {
            day.activity = [];
          }
          
          // Find existing checkin activity or create a new one
          let checkinActivityIndex = day.activity.findIndex(act => act.activity_type === 'checkin');
          
          if (checkinActivityIndex !== -1) {
            // Update existing checkin activity
            day.activity[checkinActivityIndex].hotel_name = accommodation.hotel;
            day.activity[checkinActivityIndex].mealPlan = accommodation.basis;
            // Add price information if needed
            day.activity[checkinActivityIndex].sgl_price = accommodation.sglPrice.toString();
            day.activity[checkinActivityIndex].dbl_price = accommodation.dblPrice.toString();
            day.activity[checkinActivityIndex].tpl_price = accommodation.tplPrice.toString();
            
            // Add selected booking period information if available
            if (selectedBookingPeriods[index]) {
              day.activity[checkinActivityIndex].selected_booking_period = {
                booking_start: selectedBookingPeriods[index].booking_period?.booking_start,
                booking_end: selectedBookingPeriods[index].booking_period?.booking_end,
                meal_plan: selectedBookingPeriods[index].adult_room_rate?.[0]?.meal_plan,
                adult_room_rates: selectedBookingPeriods[index].adult_room_rate,
                child_room_rates: selectedBookingPeriods[index].child_room_rates,
                pop_up_details: selectedBookingPeriods[index].pop_up,
                meal_rates: selectedBookingPeriods[index].meal_rate,
                full_booking_entry: selectedBookingPeriods[index] // Store complete booking data
              };
            }
          } else {
            // Create new checkin activity
            const newCheckinActivity = {
              activity_type: 'checkin',
              city: accommodation.city,
              inclusion: true,
              arrangement: 'Company Arrangement',
              hotel_name: accommodation.hotel,
              mealPlan: accommodation.basis,
              type: 'Mandatory',
              sgl_price: accommodation.sglPrice.toString(),
              dbl_price: accommodation.dblPrice.toString(),
              tpl_price: accommodation.tplPrice.toString(),
              tickets_price: false,
              ticketAvailability: false,
              taxAvailable: false
            };
            
            // Add selected booking period information if available
            if (selectedBookingPeriods[index]) {
              newCheckinActivity.selected_booking_period = {
                booking_start: selectedBookingPeriods[index].booking_period?.booking_start,
                booking_end: selectedBookingPeriods[index].booking_period?.booking_end,
                meal_plan: selectedBookingPeriods[index].adult_room_rate?.[0]?.meal_plan,
                adult_room_rates: selectedBookingPeriods[index].adult_room_rate,
                child_room_rates: selectedBookingPeriods[index].child_room_rates,
                pop_up_details: selectedBookingPeriods[index].pop_up,
                meal_rates: selectedBookingPeriods[index].meal_rate,
                full_booking_entry: selectedBookingPeriods[index] // Store complete booking data
              };
            }
            
            day.activity.push(newCheckinActivity);
          }
        }
      });
    }
    
    // Also update the old structure for backward compatibility
    if (!updatedItineraryData.itinerary_cost) {
      updatedItineraryData.itinerary_cost = [];
    }
    
    // Calculate total adults for price calculation
    const totalAdults = numAdults;
    
    // Update accommodation data for each day in itinerary_cost
    accommodations.forEach((accommodation, index) => {
      const dayNumber = accommodation.day;
      const dayString = dayNumber.startsWith('Day ') ? dayNumber : `Day ${dayNumber.toString().padStart(2, '0')}`;
      
      // Find or create the day entry
      let dayCostIndex = updatedItineraryData.itinerary_cost.findIndex(cost => cost.day === dayString);
      if (dayCostIndex === -1) {

        
        updatedItineraryData.itinerary_cost.push({
          day: dayString,
          date: accommodation.date || "Not Selected",
          city: accommodation.city || "",
          accommodation: {},
          day_total_cost: "0.00",
          day_total_cost_with_tax: "0.00"
        });
        dayCostIndex = updatedItineraryData.itinerary_cost.length - 1;
      }

      // Calculate total prices (using direct values, not multiplied)
      const sglTotal = (parseFloat(accommodation.sglPrice) || 0);
      const dblTotal = (parseFloat(accommodation.dblPrice) || 0);
      const tplTotal = (parseFloat(accommodation.tplPrice) || 0);
      
      // Update accommodation data
      // Attach pop_up details from accommodationApiResponse if available
      let popUpDetails = null;
      if (accommodationApiResponse) {
        const key = `${accommodation.hotel}_${accommodation.date}`;
        const entry = accommodationApiResponse[key];
        if (entry && entry.pop_up) popUpDetails = entry.pop_up;
      }
      
      // Calculate per-day With Bed and Without Bed totals for each room type
      const sglWithBedTotal = (parseFloat(accommodation.sglExtra1) || 0) * numChildren;
      const sglWithoutBedTotal = (parseFloat(accommodation.sglExtra2) || 0) * numChildren;
      const dblWithBedTotal = (parseFloat(accommodation.dblExtra1) || 0) * numChildren;
      const dblWithoutBedTotal = (parseFloat(accommodation.dblExtra2) || 0) * numChildren;
      const tplWithBedTotal = (parseFloat(accommodation.tplExtra1) || 0) * numChildren;
      const tplWithoutBedTotal = (parseFloat(accommodation.tplExtra2) || 0) * numChildren;
      
     // In the saveChanges function, in the itinerary_cost section, modify this part:
updatedItineraryData.itinerary_cost[dayCostIndex].accommodation = {
  hotel_name: accommodation.hotel,
  basis: accommodation.basis,
  room_category: accommodation.roomCategory,
  sgl_price: sglTotal.toFixed(2),
  sgl_price_per_person: (parseFloat(accommodation.sglPrice) || 0).toFixed(2),
  sglTaxIncluded: !!accommodation.sglTaxIncluded,
  sgl_with_bed_total: sglWithBedTotal,
  sgl_without_bed_total: sglWithoutBedTotal,
  sgl_with_bed_price_per_person: (parseFloat(accommodation.sglExtra1) || 0).toFixed(2),
  sgl_without_bed_price_per_person: (parseFloat(accommodation.sglExtra2) || 0).toFixed(2),
  dbl_price: dblTotal.toFixed(2),
  dbl_price_per_person: (parseFloat(accommodation.dblPrice) || 0).toFixed(2),
  dblTaxIncluded: !!accommodation.dblTaxIncluded,
  dbl_with_bed_total: dblWithBedTotal,
  dbl_without_bed_total: dblWithoutBedTotal,
  dbl_with_bed_price_per_person: (parseFloat(accommodation.dblExtra1) || 0).toFixed(2),
  dbl_without_bed_price_per_person: (parseFloat(accommodation.dblExtra2) || 0).toFixed(2),
  tpl_price: tplTotal.toFixed(2),
  tpl_price_per_person: (parseFloat(accommodation.tplPrice) || 0).toFixed(2),
  tplTaxIncluded: !!accommodation.tplTaxIncluded,
  tpl_with_bed_total: tplWithBedTotal,
  tpl_without_bed_total: tplWithoutBedTotal,
  tpl_with_bed_price_per_person: (parseFloat(accommodation.tplExtra1) || 0).toFixed(2),
  tpl_without_bed_price_per_person: (parseFloat(accommodation.tplExtra2) || 0).toFixed(2),
  roomSelection: accommodation.roomSelection || { sgl: false, dbl: false, tpl: false },
  pop_up_details: popUpDetails,
  manually_updated: true,
  
  // MODIFIED: Save the selected booking period
  selected_booking_period: selectedBookingPeriods[index] ? {
    booking_start: selectedBookingPeriods[index].booking_period?.booking_start,
    booking_end: selectedBookingPeriods[index].booking_period?.booking_end,
    meal_plan: selectedBookingPeriods[index].adult_room_rate?.[0]?.meal_plan,
    adult_room_rates: selectedBookingPeriods[index].adult_room_rate,
    child_room_rates: selectedBookingPeriods[index].child_room_rates,
    pop_up_details: selectedBookingPeriods[index].pop_up,
    meal_rates: selectedBookingPeriods[index].meal_rate,
    full_booking_entry: selectedBookingPeriods[index]
  } : null,
  
// MODIFIED: Save ALL available booking periods - preserve existing data if no new API response
all_available_booking_periods: (() => {
  // First try to get from fresh accommodationApiResponse
  if (accommodationApiResponse) {
    const possibleKeys = [
      `${accommodation.hotel}_${accommodation.date}`,
      `Date_${index + 1}_${accommodation.hotel}_${accommodation.date}`,
      `Date_${index + 1}_${accommodation.hotel}_${accommodation.date} 00:00:00`,
      `Date_${index + 1}_${accommodation.hotel}_${accommodation.date.split(' ')[0]} 00:00:00`,
      // Also try to find by hotel name in any key
      ...Object.keys(accommodationApiResponse).filter(key => 
        key.includes(accommodation.hotel) && (
          key.includes(accommodation.date) || 
          key.includes(accommodation.date.split(' ')[0]) ||
          key.includes(accommodation.date.split('T')[0])
        )
      )
    ];
    
    for (const key of possibleKeys) {
      if (accommodationApiResponse[key] && Array.isArray(accommodationApiResponse[key])) {
        console.log(`Saving all available booking periods for ${accommodation.hotel} with key: ${key}`);
        return accommodationApiResponse[key];
      }
    }
  }
  
  // ADDED: If no fresh API response, preserve existing all_available_booking_periods from accommodation object
  if (accommodation.all_available_booking_periods && Array.isArray(accommodation.all_available_booking_periods)) {
    console.log(`Preserving existing all_available_booking_periods for ${accommodation.hotel}:`, accommodation.all_available_booking_periods.length, 'periods');
    return accommodation.all_available_booking_periods;
  }
  
  return null;
})()
};
      // Print the JSON for this day's accommodation for debug
      console.log('AccommodationPopup: Saving accommodation for day', accommodation.day, JSON.stringify(updatedItineraryData.itinerary_cost[dayCostIndex].accommodation, null, 2));
      
      // Calculate and update the day's total accommodation cost
      const accommodationTotal = parseFloat(accommodation.sglPrice) + parseFloat(accommodation.dblPrice) + parseFloat(accommodation.tplPrice);
      updatedItineraryData.itinerary_cost[dayCostIndex].accommodation_total = Number(accommodationTotal).toFixed(2);
      
      // Add accommodation_total to day_total_cost
      const prevDayTotal = parseFloat(updatedItineraryData.itinerary_cost[dayCostIndex].day_total_cost) || 0;
      updatedItineraryData.itinerary_cost[dayCostIndex].day_total_cost = (prevDayTotal + accommodationTotal).toFixed(2);
    });
    
    // Prepare payload
    const apiPayload = {
      itinerary_id: itineraryId,
      updates: updatedItineraryData,
      price_change: true
    };
    
    console.log('AccommodationPopup: update_itinerary_data body:', JSON.stringify(apiPayload, null, 2));
    
    // Send update request
    const response = await makeAuthenticatedRequest(
      "https://us-central1-evoq-travel-craft.cloudfunctions.net/update_itinerary_data",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(apiPayload),
      }
    );
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`Failed to update accommodation: ${response.status} - ${errorData.error || "Unknown error"}`);
    }
    
    const result = await response.json();
    console.log('AccommodationPopup: Successfully updated accommodation:', result);
  // Clear accommodationApiResponse only if we want to fetch fresh data next time
// Keep it for now to preserve booking periods data for subsequent saves
console.log('Successfully saved accommodation data - keeping API response for future saves');
    
    // Close the popup when done
    onClose();
  } catch (err) {
    console.error('AccommodationPopup: Error saving accommodation data:', err);
    setError(err.message);
  } finally {
    setUpdating(false);
  }
};

  // Track which input cell is being edited: { row: index, type: 'sgl'|'dbl'|'tpl' } | null
  const [editingCell, setEditingCell] = useState(null);
  // Local value for currently edited input
  const [editingCellValue, setEditingCellValue] = useState('');
  // Track if tax was toggled before input for each cell (key: `${row}-${type}`)
  const [taxToggledBeforeInput, setTaxToggledBeforeInput] = useState({});

  // Calculate the total for each price category (using only adults)
  // const calculateTotals = () => {
  //   let sglTotal = 0;
  //   let dblTotal = 0;
  //   let tplTotal = 0;
  //   const totalAdults = numAdults;
  //   accommodations.forEach(acc => {
  //     sglTotal += (parseFloat(acc.sglPrice) || 0) * totalAdults;
  //     dblTotal += (parseFloat(acc.dblPrice) || 0) * Math.ceil(totalAdults / 2);
  //     tplTotal += (parseFloat(acc.tplPrice) || 0) * Math.ceil(totalAdults / 3);
  //   });
  //   return { sglTotal, dblTotal, tplTotal };
  // };

  // Calculate the total for each price category (using direct values from adult inputs)
const calculateTotals = () => {
  let sglTotal = 0;
  let dblTotal = 0;
  let tplTotal = 0;
  
  accommodations.forEach(acc => {
    sglTotal += (parseFloat(acc.sglPrice) || 0); // Remove multiplication
    dblTotal += (parseFloat(acc.dblPrice) || 0); // Remove multiplication  
    tplTotal += (parseFloat(acc.tplPrice) || 0); // Remove multiplication
  });
  
  return { sglTotal, dblTotal, tplTotal };
};

  // Helper: handle Enter key to blur input
  const handleInputKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.target.blur();
    }
  };


  // Static fallback basis options
  const fallbackBasisOptions = ['H/B', 'F/B', 'B/B', 'R/O', 'A/I', 'Lunch', 'Dinner'];

  // --- Expandable totals state ---
  const [totalsExpanded, setTotalsExpanded] = useState(false);

  // --- Calculate With Bed and Without Bed totals for each room type ---
  const withBedTotals = { sgl: 0, dbl: 0, tpl: 0 };
  const withoutBedTotals = { sgl: 0, dbl: 0, tpl: 0 };
  accommodations.forEach(acc => {
    if (roomSelection.sgl && acc.sglExtra1) withBedTotals.sgl += (parseFloat(acc.sglExtra1) || 0) * numChildren;
    if (roomSelection.sgl && acc.sglExtra2) withoutBedTotals.sgl += (parseFloat(acc.sglExtra2) || 0) * numChildren;
    if (roomSelection.dbl && acc.dblExtra1) withBedTotals.dbl += (parseFloat(acc.dblExtra1) || 0) * numChildren;
    if (roomSelection.dbl && acc.dblExtra2) withoutBedTotals.dbl += (parseFloat(acc.dblExtra2) || 0) * numChildren;
    if (roomSelection.tpl && acc.tplExtra1) withBedTotals.tpl += (parseFloat(acc.tplExtra1) || 0) * numChildren;
    if (roomSelection.tpl && acc.tplExtra2) withoutBedTotals.tpl += (parseFloat(acc.tplExtra2) || 0) * numChildren;
  });

  if (!isOpen) return null;

  if (loading) {

    // Handle keyboard navigation

    return (
      <div className="fixed inset-0 bg-gray-900 bg-opacity-75 flex items-center justify-center z-50">
        <div className="bg-white border border-blue-200 rounded-lg shadow-xl p-6 w-full max-w-md">
          <p className="text-blue-800 text-center">Loading accommodation data...</p>
        </div>
      </div>
    );
  }

  if (updating) {
    return (
      <div className="fixed inset-0 bg-gray-900 bg-opacity-75 flex items-center justify-center z-50">
        <div className="bg-white border border-blue-200 rounded-lg shadow-xl p-6 w-full max-w-md">
          <p className="text-blue-800 text-center">Updating accommodation data...</p>
        </div>
      </div>
    );
  }

  // DEBUG: Log current accommodations state on render
  console.log('AccommodationPopup: current accommodations state:', accommodations);

  return (
    <div className="fixed inset-0 bg-gray-900 bg-opacity-75 flex items-center justify-center z-50 transition-opacity duration-300 ease-in-out">
      <div 
        className="bg-white border border-blue-200 rounded-lg shadow-xl w-full max-w-[90vw] max-h-[95vh] relative transform transition-all duration-300 ease-in-out overflow-hidden flex flex-col" 
        style={{ 
          background: 'linear-gradient(to bottom right, #ffffff, #f7fbff)',
          boxShadow: '0 10px 25px -5px rgba(59, 130, 246, 0.5), 0 8px 10px -6px rgba(59, 130, 246, 0.3)'
        }}>
        {/* Close icon */}
        <button 
          onClick={onClose}
          className="absolute top-2 right-2 text-blue-500 hover:text-blue-700 transition-colors z-10"
          aria-label="Close"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

      {/* Document popup/modal (global, outside table) */}
    

{documentPopupIndex !== null && accommodations[documentPopupIndex] && (
  <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
    <div className="bg-white rounded-lg shadow-lg p-6 max-w-4xl w-full relative border border-blue-300 max-h-[80vh] overflow-y-auto">
      <button
        className="absolute top-2 right-2 text-blue-500 hover:text-blue-700"
        onClick={() => setDocumentPopupIndex(null)}
        aria-label="Close"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
      
      <h3 className="text-lg font-semibold text-blue-800 mb-4">
        Hotel Details
        {selectedBookingPeriods[documentPopupIndex] && selectedBookingPeriods[documentPopupIndex].booking_period && (
          <span className="text-sm font-normal text-gray-600 block">
            Showing details for: {selectedBookingPeriods[documentPopupIndex].booking_period.booking_start} to {selectedBookingPeriods[documentPopupIndex].booking_period.booking_end}
          </span>
        )}
      </h3>

     {hasBookingPeriods(accommodations[documentPopupIndex], documentPopupIndex) && (
        <div className="mb-4">
          <button
            onClick={() => {
              setDocumentPopupIndex(null);
              setCalendarPopupOpen({ rowIndex: documentPopupIndex });
            }}
            className="px-3 py-1 text-sm bg-blue-100 text-blue-700 rounded hover:bg-blue-200 transition-colors"
          >
            Switch Booking Period
          </button>
        </div>
      )}
      
      {/* Basic Hotel Information */}
      <div className="flex flex-col gap-2 mb-6">
        <div className="flex flex-row flex-wrap items-center gap-6">
          <div className="flex items-center gap-1 text-gray-700">
            <span className="font-semibold">Hotel:</span>
            <span>{String(accommodations[documentPopupIndex].hotel)}</span>
          </div>
          <div className="flex items-center gap-1 text-gray-700">
            <span className="font-semibold">City:</span>
            <span>{String(accommodations[documentPopupIndex].city)}</span>
          </div>
        </div>
        <div className="flex flex-row flex-wrap items-center gap-6">
          <div className="flex items-center gap-1 text-gray-700">
            <span className="font-semibold">Room Category:</span>
            <span>{String(accommodations[documentPopupIndex].roomCategory)}</span>
          </div>
          <div className="flex items-center gap-1 text-gray-700">
            <span className="font-semibold">Basis:</span>
            <span>{String(accommodations[documentPopupIndex].basis)}</span>
          </div>
        </div>
      </div>

      {(() => {
        // Get pop_up details from API response - prioritize selected booking period
        const acc = accommodations[documentPopupIndex];
        let popUp = null;
        let entryData = null; // Store the full entry data
        
        // MODIFIED: First, check if we have a selected booking period for this row
        if (selectedBookingPeriods[documentPopupIndex]) {
          entryData = selectedBookingPeriods[documentPopupIndex];
          if (entryData && entryData.pop_up) {
            popUp = entryData.pop_up;
            // Add child_room_rates and meal_rate from entry level to popUp
            if (entryData.child_room_rates) {
              popUp.child_room_rates = entryData.child_room_rates;
            }
            if (entryData.meal_rate) {
              popUp.meal_rate = entryData.meal_rate;
            }
              if (entryData.Extra_costs) {
  popUp.Extra_costs = entryData.Extra_costs;
}
            
          }
        } else {
          // NEW: If no selected booking period, try to find matching entry based on current prices
          console.log('No selected booking period, trying to find matching entry for current prices');
          
          // Helper function to find matching booking period based on current prices
          const findMatchingBookingPeriodForPopup = () => {
            const currentSglPrice = parseFloat(acc.sglPrice) || 0;
            const currentDblPrice = parseFloat(acc.dblPrice) || 0;
            const currentTplPrice = parseFloat(acc.tplPrice) || 0;
            const currentBasis = acc.basis;
            
            let availableData = null;
            
            // First try accommodationApiResponse
            if (accommodationApiResponse) {
              const possibleKeys = [
                `${acc.hotel}_${acc.date}`,
                `Date_${documentPopupIndex + 1}_${acc.hotel}_${acc.date}`,
                `Date_${documentPopupIndex + 1}_${acc.hotel}_${acc.date} 00:00:00`,
                `Date_${documentPopupIndex + 1}_${acc.hotel}_${acc.date.split(' ')[0]} 00:00:00`,
                `Date_${documentPopupIndex + 1}_${acc.hotel}_${acc.date.split('T')[0]} 00:00:00`,
                ...Object.keys(accommodationApiResponse).filter(key => 
                  key.includes(acc.hotel) && (
                    key.includes(acc.date) || 
                    key.includes(acc.date.split(' ')[0]) ||
                    key.includes(acc.date.split('T')[0])
                  )
                )
              ];
              
              for (const key of possibleKeys) {
                if (accommodationApiResponse[key] && Array.isArray(accommodationApiResponse[key])) {
                  availableData = accommodationApiResponse[key];
                  break;
                }
              }
            }
            
            // Fallback to saved booking periods data
            if (!availableData && acc.all_available_booking_periods) {
              availableData = acc.all_available_booking_periods;
            }
            
            if (!availableData || !Array.isArray(availableData)) {
              return null;
            }
            
            // Find entry that matches current prices and meal plan
            const matchingEntry = availableData.find(entry => {
              if (!entry.adult_room_rate || !Array.isArray(entry.adult_room_rate)) return false;
              
              // Check meal plan match
              const entryMealPlan = entry.adult_room_rate[0]?.meal_plan;
              const entryBasisNormalized = entryMealPlan?.toUpperCase().replace('/', '');
              const accBasisNormalized = currentBasis.toUpperCase().replace('/', '');
              
              if (entryBasisNormalized !== accBasisNormalized) return false;
              
              // Check if any room rates match current prices
              const roomRates = entry.adult_room_rate;
              const sglRate = roomRates.find(r => r.room_occupancy_type === 'single');
              const dblRate = roomRates.find(r => r.room_occupancy_type === 'double');
              const tplRate = roomRates.find(r => r.room_occupancy_type === 'triple');
              
              // Check if at least one selected room type matches
              let hasMatch = false;
              
              if (roomSelection.sgl && sglRate && Math.abs((sglRate.adult_room_cost || 0) - currentSglPrice) < 0.01) {
                hasMatch = true;
              }
              if (roomSelection.dbl && dblRate && Math.abs((dblRate.adult_room_cost || 0) - currentDblPrice) < 0.01) {
                hasMatch = true;
              }
              if (roomSelection.tpl && tplRate && Math.abs((tplRate.adult_room_cost || 0) - currentTplPrice) < 0.01) {
                hasMatch = true;
              }
              
              return hasMatch;
            });
            
            return matchingEntry;
          };
          
          // Try to find matching entry
          const matchingEntry = findMatchingBookingPeriodForPopup();
          if (matchingEntry) {
            entryData = matchingEntry;
            if (entryData && entryData.pop_up) {
              popUp = entryData.pop_up;
              // Add child_room_rates and meal_rate from entry level to popUp
              if (entryData.child_room_rates) {
                popUp.child_room_rates = entryData.child_room_rates;
              }
              if (entryData.meal_rate) {
                popUp.meal_rate = entryData.meal_rate;
              }

              if (entryData.Extra_costs) {
  popUp.Extra_costs = entryData.Extra_costs;
}
            }
            console.log('Found matching entry for current prices:', matchingEntry);
          }
        }
        
        // MODIFIED: Only use fallback methods if no match found above
        if (!popUp && accommodationApiResponse && acc) {
          const possibleKeys = [
            `${acc.hotel}_${acc.date}`,
            `Date_${documentPopupIndex + 1}_${acc.hotel}_${acc.date} 00:00:00`,
            Object.keys(accommodationApiResponse).find(key => key.includes(acc.hotel))
          ].filter(Boolean);
          
          for (const key of possibleKeys) {
            if (accommodationApiResponse[key] && Array.isArray(accommodationApiResponse[key])) {
              // MODIFIED: Instead of using first entry, try to find one matching current meal plan
              const entries = accommodationApiResponse[key];
              const matchingMealPlanEntry = entries.find(entry => {
                const entryMealPlan = entry.adult_room_rate?.[0]?.meal_plan;
                const entryBasisNormalized = entryMealPlan?.toUpperCase().replace('/', '');
                const accBasisNormalized = acc.basis.toUpperCase().replace('/', '');
                return entryBasisNormalized === accBasisNormalized;
              });
              
              entryData = matchingMealPlanEntry || entries[0]; // Fallback to first if no meal plan match
              if (entryData && entryData.pop_up) {
                popUp = entryData.pop_up;
                // Add child_room_rates and meal_rate from entry level to popUp
                if (entryData.child_room_rates) {
                  popUp.child_room_rates = entryData.child_room_rates;
                }
                if (entryData.meal_rate) {
                  popUp.meal_rate = entryData.meal_rate;
                }
                  if (entryData.Extra_costs) {
  popUp.Extra_costs = entryData.Extra_costs;
}
                break;
              }
            }
          }
        }
        
        // Final fallback: stored pop_up_details
        if (!popUp && acc && acc.pop_up_details) {
          popUp = acc.pop_up_details;
        }
        
        if (!popUp) {
          return (
            <div className="text-gray-500 mt-4">
              <p>No additional details available for this hotel.</p>
            {hasBookingPeriods(acc, documentPopupIndex) && (
  <p className="mt-2 text-sm">
    <strong>Note:</strong> This hotel has booking periods available. 
    Select a specific booking period using the "Switch Booking Period" button above to view detailed information.
  </p>
)}
            </div>
          );
        }

        // Rest of your existing rendering code remains the same...
        // Helper functions for rendering tables and content
        const renderTable = (title, data, isArray = false) => {
          if (!data || (isArray && (!Array.isArray(data) || data.length === 0))) return null;
          
          return (
            <div className="mb-6">
              <div className="font-bold text-blue-700 mb-3 text-base border-b border-blue-200 pb-1">
                {title}
              </div>
              
              {isArray ? (
                <div className="overflow-x-auto">
                  <table className="w-full border border-blue-200 rounded-lg bg-white text-sm">
                    <thead>
                      <tr className="bg-blue-100">
                        {data.length > 0 && Object.keys(data[0]).map((col, idx) => (
                          <th key={idx} className="py-2 px-3 font-semibold text-blue-900 border-b border-blue-200 text-left">
                            {col.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {data.map((item, rowIdx) => (
                        <tr key={rowIdx} className={rowIdx % 2 === 0 ? 'bg-blue-50' : 'bg-white'}>
                          {Object.entries(item).map(([key, val], colIdx) => (
                            <td key={colIdx} className="py-2 px-3 text-gray-900 border-b border-blue-100">
                              {key === 'child_age_group' && typeof val === 'object' && val !== null ? 
                                `${val.starting_age} - ${val.ending_age} years` :
                                typeof val === 'object' && val !== null ? 
                                  JSON.stringify(val) : 
                                  String(val || '-')
                              }
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="bg-blue-50 p-4 rounded-lg">
                  <table className="w-full">
                    <tbody>
                      {Object.entries(data).map(([key, value], idx) => (
                        <tr key={idx}>
                          <td className="py-1 px-2 font-semibold text-blue-900 w-1/3">
                            {key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}:
                          </td>
                          <td className="py-1 px-2 text-gray-900">
                            {typeof value === 'object' && value !== null 
                              ? JSON.stringify(value) 
                              : String(value || '-')
                            }
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          );
        };

        const renderList = (title, items) => {
          if (!items || !Array.isArray(items) || items.length === 0) return null;
          
          return (
            <div className="mb-6">
              <div className="font-bold text-blue-700 mb-3 text-base border-b border-blue-200 pb-1">
                {title}
              </div>
              <div className="bg-blue-50 p-4 rounded-lg">
                <ul className="list-disc ml-6 space-y-2">
                  {items.map((item, idx) => (
                    <li key={idx} className="text-gray-800">
                      {String(item)}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          );
        };

        const sections = [];

          if (popUp.market_type) {
          sections.push(
            <div className="mb-6" key="market-type">
              <div className="font-bold text-blue-700 mb-3 text-base border-b border-blue-200 pb-1">
                Market Type
              </div>
              <div className="bg-blue-50 p-4 rounded-lg">
                <span className="text-gray-800">{popUp.market_type}</span>
              </div>
            </div>
          );
        }

        // Child Room Rates Table (display only - from entry level data)
        if (popUp.child_room_rates && Array.isArray(popUp.child_room_rates)) {
          sections.push(renderTable('Child Room Rates', popUp.child_room_rates, true));
        }

        if (popUp.Extra_costs && Array.isArray(popUp.Extra_costs)) {
  sections.push(renderTable('Extra Costs', popUp.Extra_costs, true));
}

        // Adult Meal Rates Table
        if (popUp.meal_rate && popUp.meal_rate.adult_meal_rates && Array.isArray(popUp.meal_rate.adult_meal_rates)) {
          sections.push(renderTable('Adult Meal Rates', popUp.meal_rate.adult_meal_rates, true));
        }

        // Child Meal Rates Table
        if (popUp.meal_rate && popUp.meal_rate.child_meal_rates && Array.isArray(popUp.meal_rate.child_meal_rates)) {
          sections.push(renderTable('Child Meal Rates', popUp.meal_rate.child_meal_rates, true));
        }

        // Rest of existing sections...
        if (popUp.Supplements && Array.isArray(popUp.Supplements)) {
          sections.push(renderTable('Supplements', popUp.Supplements, true));
        }

        if (popUp.Reductions && Array.isArray(popUp.Reductions)) {
          sections.push(renderTable('Reductions', popUp.Reductions, true));
        }

        if (popUp.Early_birds_offers && Array.isArray(popUp.Early_birds_offers)) {
          sections.push(renderTable('Early Bird Offers', popUp.Early_birds_offers, true));
        }

        if (popUp.last_min_offers && Array.isArray(popUp.last_min_offers) && popUp.last_min_offers.length > 0) {
          sections.push(renderTable('Last Minute Offers', popUp.last_min_offers, true));
        }

        if (popUp.special_conditions_and_offers && Array.isArray(popUp.special_conditions_and_offers)) {
          sections.push(renderList('Special Conditions & Offers', popUp.special_conditions_and_offers));
        }

        if (popUp.Guide_policies && Array.isArray(popUp.Guide_policies)) {
          sections.push(renderList('Guide Policies', popUp.Guide_policies));
        }

        if (popUp.rate_breakdown && typeof popUp.rate_breakdown === 'object') {
          sections.push(renderTable('Rate Breakdown', popUp.rate_breakdown, false));
        }

        if (popUp.tax_info && typeof popUp.tax_info === 'object') {
          sections.push(renderTable('Tax Information', popUp.tax_info, false));
        }

        if (popUp.meal_plans && typeof popUp.meal_plans === 'object') {
          sections.push(renderTable('Meal Plans', popUp.meal_plans, false));
        }

      

        return (
          <div className="space-y-6">
            {sections.length > 0 ? sections : (
              <div className="text-gray-500">No detailed information available.</div>
            )}
          </div>
        );
      })()}
    </div>
  </div>
)}
{/* Calendar popup for booking periods */}
{calendarPopupOpen && (
  <CalendarPopup
    rowIndex={calendarPopupOpen.rowIndex}
    onClose={() => setCalendarPopupOpen(null)}
  />
)}
        {/* Header */}
        <div className="p-4 border-b border-blue-200 sticky top-0 bg-white z-10 shadow-sm">
          <h2 className="text-blue-800 text-center font-bold text-xl uppercase tracking-wider">ACCOMMODATION</h2>
        </div>
        
        {loading ? (
          <div className="flex justify-center items-center h-32">
            <span className="text-lg text-blue-600">Loading...</span>
          </div>
        ) : error ? (
          <div className="bg-red-100 text-red-700 p-2 rounded mb-4 text-center border border-red-200">{error}</div>
        ) : (
          <div className="flex-1 overflow-hidden p-4">
            {/* Show number of adults and children above the table */}
            {/* Show number of adults, children, and booking information above the table */}
<div className="mb-3 flex items-center justify-between">
  <div className="flex items-center space-x-6">
    <span className="text-blue-900 font-semibold">Adults: <span className="font-bold">{numAdults}</span></span>
    <span className="text-blue-900 font-semibold">Children: <span className="font-bold">{numChildren}</span></span>
  </div>
  
  {/* Booking Information Display */}
  <div className="flex items-center space-x-4">
    {bookingType === "period" && (bookingStartDate || bookingEndDate) ? (
      <div className="text-blue-900 font-semibold">
        Booking Period: 
        <span className="font-bold ml-1">
          {bookingStartDate && bookingEndDate 
            ? `${bookingStartDate} to ${bookingEndDate}`
            : bookingStartDate 
              ? `From ${bookingStartDate}`
              : bookingEndDate 
                ? `Until ${bookingEndDate}`
                : "Not specified"
          }
        </span>
      </div>
    ) : bookingType === "date" && specificBookingDate ? (
      <div className="text-blue-900 font-semibold">
        Booking Date: <span className="font-bold">{specificBookingDate}</span>
      </div>
    ) : (
      <div className="text-gray-500 font-medium text-sm">
        No booking date specified
      </div>
    )}
  </div>
</div>
           {/* Replace the existing overflow-auto div with this responsive container */}
<div className="overflow-x-auto max-h-[calc(90vh-180px)] rounded-lg shadow-inner">
  <div className="min-w-[800px]"> {/* Ensures minimum width for table integrity */}
    <table className="w-full border-collapse">
                <thead className="sticky top-0 z-10">
                 <tr className="bg-blue-100">
  <th className="border border-blue-200 p-2 sm:p-3 text-blue-700 text-center font-medium text-xs uppercase tracking-wider sticky top-0 min-w-[60px]">Day</th>
  <th className="border border-blue-200 p-2 sm:p-3 text-blue-700 text-center font-medium text-xs uppercase tracking-wider sticky top-0 min-w-[80px]">City</th>
  <th className="border border-blue-200 p-2 sm:p-3 text-blue-700 text-center font-medium text-xs uppercase tracking-wider sticky top-0 min-w-[200px] max-w-[300px]">Hotel</th>
  <th className="border border-blue-200 p-2 sm:p-3 text-blue-700 text-center font-medium text-xs uppercase tracking-wider sticky top-0 min-w-[120px] max-w-[200px]">Room Category</th>
  <th className="border border-blue-200 p-2 sm:p-3 text-blue-700 text-center font-medium text-xs uppercase tracking-wider sticky top-0 min-w-[100px] max-w-[150px]">Basis</th>
  {/* SGL, DBL, TPL headers remain the same */}
                    <th className="border border-blue-200 p-3 text-blue-700 text-right font-medium text-xs uppercase tracking-wider sticky top-0">
  <label className="flex items-center justify-end space-x-1 cursor-pointer select-none">
    <input
      type="checkbox"
      className="h-4 w-4 text-blue-600 border-blue-300 rounded focus:ring-blue-500"
      checked={roomSelection.sgl}
      onChange={() => handleRoomSelectionChange('sgl')}
    />
    <span>SGL</span>
  </label>
</th>
<th className="border border-blue-200 p-3 text-blue-700 text-right font-medium text-xs uppercase tracking-wider sticky top-0">
  <label className="flex items-center justify-end space-x-1 cursor-pointer select-none">
    <input
      type="checkbox"
      className="h-4 w-4 text-blue-600 border-blue-300 rounded focus:ring-blue-500"
      checked={roomSelection.dbl}
      onChange={() => handleRoomSelectionChange('dbl')}
    />
    <span>DBL</span>
  </label>
</th>
<th className="border border-blue-200 p-3 text-blue-700 text-right font-medium text-xs uppercase tracking-wider sticky top-0">
  <label className="flex items-center justify-end space-x-1 cursor-pointer select-none">
    <input
      type="checkbox"
      className="h-4 w-4 text-blue-600 border-blue-300 rounded focus:ring-blue-500"
      checked={roomSelection.tpl}
      onChange={() => handleRoomSelectionChange('tpl')}
    />
    <span>TPL</span>
  </label>
</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-blue-100">
                  {accommodations.map((acc, index) => (
                    <tr 
                      key={`acc-${index}`} 
                      className={`${index % 2 === 0 ? "bg-white" : "bg-blue-50"} hover:bg-blue-100 transition-colors`}
                    >
                      <td className="px-4 py-3 text-gray-800">
                        <div className="font-medium">{acc.day}</div>
                        <div className="text-xs text-gray-500">{acc.date}</div>
                      </td>
                      <td className="px-4 py-3 text-gray-800">
                        {acc.city}
                      </td>
                     <td className="px-2 sm:px-4 py-3 text-gray-800 min-w-[200px] max-w-[300px]">
  <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2">
    {/* Document icon */}
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-4 w-4 sm:h-5 sm:w-5 text-blue-500 flex-shrink-0 cursor-pointer hover:text-blue-700"
      fill="none"
      viewBox="0 0 20 20"
      stroke="currentColor"
      onClick={() => setDocumentPopupIndex(index)}
      title="Show hotel document info"
    >
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M7 2a2 2 0 00-2 2v12a2 2 0 002 2h6a2 2 0 002-2V8.414A2 2 0 0014.414 7L11 3.586A2 2 0 009.586 3H7z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M11 3.5V7a1 1 0 001 1h3.5" />
    </svg>

    <input
      type="text"
      value={acc.hotel}
      onChange={(e) => handleHotelChange(index, e.target.value)}
      className="w-full min-w-0 border border-blue-200 rounded px-2 py-1 text-sm sm:text-center text-left focus:outline-none focus:ring-2 focus:ring-blue-500 break-words"
      style={{ wordBreak: 'break-word' }}
    />
  </div>
</td>
{/* Room Category */}
<td className="px-2 sm:px-4 py-3 text-gray-800 min-w-[120px] max-w-[200px]">
  <span className="text-sm break-words" style={{ wordBreak: 'break-word' }}>
    {acc.roomCategory || '-'}
  </span>
</td>

{/* Basis */}
<td className="px-2 sm:px-4 py-3 text-gray-800 min-w-[100px] max-w-[150px]">
  <select
    value={acc.basis}
    onChange={(e) => handleBasisChange(index, e.target.value)}
    className="w-full border border-blue-200 rounded px-1 sm:px-2 py-1 text-sm text-center focus:outline-none focus:ring-2 focus:ring-blue-500"
  >
    {(hotelMealPlans[acc.hotel] && hotelMealPlans[acc.hotel].length > 0
      ? hotelMealPlans[acc.hotel]
      : fallbackBasisOptions
    ).map(option => (
      <option key={option} value={option}>{option}</option>
    ))}
  </select>
</td>     

{/* Add this style tag in your component or update your CSS */}
<style jsx>{`
  .break-words {
    word-wrap: break-word;
    word-break: break-word;
    hyphens: auto;
  }
  
  @media (max-width: 640px) {
    .table-container {
      font-size: 0.875rem;
    }
  }
`}</style>          <td className="px-4 py-3 text-gray-800">
                        <div className="flex items-center justify-end space-x-2">
                          <span className="mr-1">$</span>
                          <div className="flex flex-col items-center">

<div className="flex flex-col items-center">
  <label className="text-xs text-gray-700 mb-0.5">Adult</label>
  <div className="flex items-center gap-1">
    <input
      type="number"
      min="0"
      step="0.01"
      data-row={index}
      data-field="sglPrice"
      value={editingCell && editingCell.row === index && editingCell.type === 'sgl' ? 
        (editingCellValue === '0' || editingCellValue === 0 ? '' : editingCellValue) : 
        (acc.sglPrice === '0' || acc.sglPrice === 0 || !acc.sglPrice ? '' : String(Number(acc.sglPrice)))
      }
      onChange={e => {
        if (editingCell && editingCell.row === index && editingCell.type === 'sgl') {
          setEditingCellValue(e.target.value);
        } else {
          setEditingCell({ row: index, type: 'sgl' });
          setEditingCellValue(e.target.value);
        }
      }}
      onFocus={() => {
        setEditingCell({ row: index, type: 'sgl' });
        setEditingCellValue(acc.sglPrice !== undefined && acc.sglPrice !== null ? String(Number(acc.sglPrice)) : '');
        if (acc.sglTaxIncluded && taxToggledBeforeInput[`${index}-sgl`] === true) {
          // Do nothing, intent is tax-included
        } else {
          setTaxToggledBeforeInput(prev => ({ ...prev, [`${index}-sgl`]: false }));
        }
      }}
      onBlur={() => {
        if (editingCell && editingCell.row === index && editingCell.type === 'sgl') {
          if (acc.sglTaxIncluded && taxToggledBeforeInput[`${index}-sgl`]) {
            const val = parseFloat(editingCellValue) || 0;
            const taxPercentage = getTaxPercentage();
            acc.sglBase = val / (1 + taxPercentage / 100);
            acc.sglPrice = val.toFixed(2);
          } else {
            handleSglPriceChange(index, editingCellValue);
          }
          setEditingCell(null);
          setEditingCellValue('');
          setTaxToggledBeforeInput(prev => ({ ...prev, [`${index}-sgl`]: false }));
        }
      }}
      onKeyDown={e => {
        if (e.key === 'Enter') {
          e.target.blur();
        } else {
          handleKeyNavigation(e, index, 'sglPrice');
        }
      }}
      className="w-20 text-center border border-blue-200 rounded px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-500"
      disabled={!!acc.isApiHotel || !roomSelection.sgl}
    />

    {/* Loading indicator overlay for SGL */}
  {loadingPrices[index] && roomSelection.sgl && (
    <div className="absolute inset-0 flex items-center justify-center bg-blue-50 bg-opacity-75 rounded">
      <LoadingSpinner size="w-4 h-4" />
    </div>
  )}
    
    {/* Calendar icon - show only if multiple booking periods exist */}
 
{hasBookingPeriods(acc, index) && roomSelection.sgl && (
  <button
    type="button"
    onClick={() => setCalendarPopupOpen({ rowIndex: index })}
    className="p-1 text-blue-600 hover:text-blue-800 bg-blue-50 hover:bg-blue-100 rounded transition-colors border border-blue-200"
    title="Select booking period"
  >
    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 002 2z" />
    </svg>
  </button>
)}
  </div>
  
  {/* Rest of the SGL section remains the same... */}
   {roomSelection.sgl && (!editingCell || editingCell.row !== index || editingCell.type !== 'sgl') && (
       <div className="flex justify-center items-center mt-1">
    <span className="text-xs text-black-500 whitespace-nowrap">
      ${formatCurrency(acc.sglPrice)} {/* Remove the multiplication display */}
    </span>
  </div>
    // <div className="flex justify-center items-center mt-1">
    //   <span className="text-xs text-black-500  whitespace-nowrap">
    //     {numAdults}
    //   </span>
    //   <span className="mx-1 text-xs text-black-500">*</span>
    //   <span className="text-xs text-black-500  whitespace-nowrap">
    //     ${formatCurrency(acc.sglPrice)}
    //   </span>
    //   <span className="mx-1 text-xs text-black-500">=</span>
    //   <span className="text-xs text-black-500  whitespace-nowrap">
    //     ${formatCurrency((parseFloat(acc.sglPrice) || 0) * numAdults)}
    //   </span>
    // </div>
  )}
  </div>
  <div className="flex flex-row justify-center gap-1 mt-1">
  {roomSelection.sgl && (
  <>

 
    <div className="flex flex-col items-center">
      <label className="text-xs text-gray-700 mb-0.5">With Bed</label>
     <input
  type="number"
  min="0"
  step="0.01"
  data-row={index}
  data-field="sglExtra1"
  value={acc.sglExtra1 === '0' || acc.sglExtra1 === 0 ? '' : (acc.sglExtra1 || '')}
  onChange={e => {
    const updated = [...accommodations];
    updated[index].sglExtra1 = e.target.value;
    setAccommodations(updated);
  }}
  onKeyDown={e => handleKeyNavigation(e, index, 'sglExtra1')}
  className="w-10 text-center border border-blue-200 rounded px-1 py-0.5 text-xs"
  placeholder="With Bed"
  style={{ fontSize: '11px' }}
  disabled={!!acc.isApiHotel || !roomSelection.sgl}
/>
      <span className="text-[10px] text-gray-600 mt-0.5">{numChildren} * {acc.sglExtra1 || 0} = {formatCurrency((parseFloat(acc.sglExtra1) || 0) * numChildren)}</span>
    </div>
    <div className="flex flex-col items-center">
      <label className="text-xs text-gray-700 mb-0.5">Without Bed</label>
     <input
  type="number"
  min="0"
  step="0.01"
  data-row={index}
  data-field="sglExtra2"
  value={acc.sglExtra2 === '0' || acc.sglExtra2 === 0 ? '' : (acc.sglExtra2 || '')}
  onChange={e => {
    const updated = [...accommodations];
    updated[index].sglExtra2 = e.target.value;
    setAccommodations(updated);
  }}
  onKeyDown={e => handleKeyNavigation(e, index, 'sglExtra2')}
  className="w-10 text-center border border-blue-200 rounded px-1 py-0.5 text-xs"
  placeholder="Without Bed"
  style={{ fontSize: '11px' }}
  disabled={!!acc.isApiHotel || !roomSelection.sgl}
/>
      <span className="text-[10px] text-gray-600 mt-0.5">{numChildren} * {acc.sglExtra2 || 0} = {formatCurrency((parseFloat(acc.sglExtra2) || 0) * numChildren)}</span>
    </div>
  </>
)}
</div>

  {/* Show SGL total calculation only if not editing this cell and SGL selected */}
 
</div>
                          <label className="flex items-center ml-2 text-xs text-blue-700">
                            <input
                              type="checkbox"
                              checked={!!acc.sglTaxIncluded}
                              onChange={() => handleSglTaxToggle(index)}
                              disabled={!!acc.isApiHotel || !roomSelection.sgl}
                              className="h-4 w-4 text-blue-600 border-blue-300 rounded focus:ring-blue-500 ml-1"
                            />
                            <span className="ml-1">Tax Included</span>
                          </label>
                          {acc.sglTaxIncluded && getTaxPercentage() > 0 && (
                            <span className="ml-2 text-xs text-blue-600">(incl. {getTaxPercentage()}% tax)</span>
                          )}
                        </div>
                      </td>
                      <td className="px-4 py-3 text-gray-800">
                        <div className="flex items-center justify-end space-x-2">
                          <span className="mr-1">$</span>
                          <div className="flex flex-col items-center">
  <div className="flex flex-col items-center">
    <label className="text-xs text-gray-700 mb-0.5">Adult</label>
    <div className="flex items-center gap-1">
   <input
  type="number"
  min="0"
  step="0.01"
  data-row={index}
  data-field="dblPrice"
  value={editingCell && editingCell.row === index && editingCell.type === 'dbl' ? 
    (editingCellValue === '0' || editingCellValue === 0 ? '' : editingCellValue) : 
    (acc.dblPrice === '0' || acc.dblPrice === 0 || !acc.dblPrice ? '' : String(Number(acc.dblPrice)))
  }
  onChange={e => {
    if (editingCell && editingCell.row === index && editingCell.type === 'dbl') {
      setEditingCellValue(e.target.value);
    } else {
      setEditingCell({ row: index, type: 'dbl' });
      setEditingCellValue(e.target.value);
    }
  }}
  onFocus={() => {
    setEditingCell({ row: index, type: 'dbl' });
    setEditingCellValue(acc.dblPrice !== undefined && acc.dblPrice !== null ? String(Number(acc.dblPrice)) : '');
    if (acc.dblTaxIncluded && taxToggledBeforeInput[`${index}-dbl`] === true) {
      // Do nothing, intent is tax-included
    } else {
      setTaxToggledBeforeInput(prev => ({ ...prev, [`${index}-dbl`]: false }));
    }
  }}
  onBlur={() => {
    if (editingCell && editingCell.row === index && editingCell.type === 'dbl') {
      if (acc.dblTaxIncluded && taxToggledBeforeInput[`${index}-dbl`]) {
        const val = parseFloat(editingCellValue) || 0;
        const taxPercentage = getTaxPercentage();
        acc.dblBase = val / (1 + taxPercentage / 100);
        acc.dblPrice = val.toFixed(2);
      } else {
        handleDblPriceChange(index, editingCellValue);
      }
      setEditingCell(null);
      setEditingCellValue('');
      setTaxToggledBeforeInput(prev => ({ ...prev, [`${index}-dbl`]: false }));
    }
  }}
  onKeyDown={e => {
    if (e.key === 'Enter') {
      e.target.blur();
    } else {
      handleKeyNavigation(e, index, 'dblPrice');
    }
  }}
  className="w-20 text-center border border-blue-200 rounded px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-500"
  disabled={!!acc.isApiHotel || !roomSelection.dbl}
/>
{/* Loading indicator overlay for SGL */}
  {loadingPrices[index] && roomSelection.dbl && (
    <div className="absolute inset-0 flex items-center justify-center bg-blue-50 bg-opacity-75 rounded">
      <LoadingSpinner size="w-4 h-4" />
    </div>
  )}

{hasBookingPeriods(acc, index) && roomSelection.dbl && (
  <button
    type="button"
    onClick={() => setCalendarPopupOpen({ rowIndex: index })}
    className="p-1 text-blue-500 hover:text-blue-700 transition-colors"
    title="Select booking period"
  >
    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 002 2z" />
    </svg>
  </button>
)}
</div>

   {roomSelection.dbl && (!editingCell || editingCell.row !== index || editingCell.type !== 'dbl') && (

       <div className="flex justify-center items-center mt-1">
    <span className="text-xs text-black-500 whitespace-nowrap">
      ${formatCurrency(acc.dblPrice)} {/* Remove the multiplication display */}
    </span>
  </div>
      // <div className="flex justify-center items-center mt-1">
      //   <span className="text-xs text-black-500  whitespace-nowrap">
      //     {Math.ceil(numAdults / 2)}
      //   </span>
      //   <span className="mx-1 text-xs text-black-500">*</span>
      //   <span className="text-xs text-black-500  whitespace-nowrap">
      //     ${formatCurrency(acc.dblPrice)}
      //   </span>
      //   <span className="mx-1 text-xs text-black-500">=</span>
      //   <span className="text-xs text-black-500  whitespace-nowrap">
      //     ${formatCurrency(((parseFloat(acc.dblPrice) || 0) * Math.ceil(numAdults / 2)))}
      //   </span>
      // </div>
    )}
    {/* DBL With Bed/Without Bed inputs */}
    {roomSelection.dbl && (
      <div className="flex flex-row justify-center gap-1 mt-1">
        <div className="flex flex-col items-center">
          <label className="text-xs text-gray-700 mb-0.5">With Bed</label>
         <input
  type="number"
  min="0"
  step="0.01"
  data-row={index}
  data-field="dblExtra1"
  value={acc.dblExtra1 === '0' || acc.dblExtra1 === 0 ? '' : (acc.dblExtra1 || '')}
  onChange={e => {
    const updated = [...accommodations];
    updated[index].dblExtra1 = e.target.value;
    setAccommodations(updated);
  }}
  onKeyDown={e => handleKeyNavigation(e, index, 'dblExtra1')}
  className="w-10 text-center border border-blue-200 rounded px-1 py-0.5 text-xs"
  placeholder="With Bed"
  style={{ fontSize: '11px' }}
  disabled={!!acc.isApiHotel || !roomSelection.dbl}
/>
          <span className="text-[10px] text-gray-600 mt-0.5">{numChildren} * {acc.dblExtra1 || 0} = {formatCurrency((parseFloat(acc.dblExtra1) || 0) * numChildren)}</span>
        </div>
        <div className="flex flex-col items-center">
          <label className="text-xs text-gray-700 mb-0.5">Without Bed</label>
         <input
  type="number"
  min="0"
  step="0.01"
  data-row={index}
  data-field="dblExtra2"
  value={acc.dblExtra2 === '0' || acc.dblExtra2 === 0 ? '' : (acc.dblExtra2 || '')}
  onChange={e => {
    const updated = [...accommodations];
    updated[index].dblExtra2 = e.target.value;
    setAccommodations(updated);
  }}
  onKeyDown={e => handleKeyNavigation(e, index, 'dblExtra2')}
  className="w-10 text-center border border-blue-200 rounded px-1 py-0.5 text-xs"
  placeholder="Without Bed"
  style={{ fontSize: '11px' }}
  disabled={!!acc.isApiHotel || !roomSelection.dbl}
/>
          <span className="text-[10px] text-gray-600 mt-0.5">{numChildren} * {acc.dblExtra2 || 0} = {formatCurrency((parseFloat(acc.dblExtra2) || 0) * numChildren)}</span>
        </div>
      </div>
    )}
  </div>
</div>
                          <label className="flex items-center ml-2 text-xs text-blue-700">
                            <input
                              type="checkbox"
                              checked={!!acc.dblTaxIncluded}
                              onChange={() => handleDblTaxToggle(index)}
                              disabled={!!acc.isApiHotel || !roomSelection.dbl}
                              className="h-4 w-4 text-blue-600 border-blue-300 rounded focus:ring-blue-500 ml-1"
                            />
                            <span className="ml-1">Tax Included</span>
                          </label>
                          {acc.dblTaxIncluded && getTaxPercentage() > 0 && (
                            <span className="ml-2 text-xs text-blue-600">(incl. {getTaxPercentage()}% tax)</span>
                          )}
                        </div>
                      </td>
                      <td className="px-4 py-3 text-gray-800">
                        <div className="flex items-center justify-end space-x-2">
                          <span className="mr-1">$</span>
                          <div className="flex flex-col items-center">
  <div className="flex flex-col items-center">
    <label className="text-xs text-gray-700 mb-0.5">Adult</label>
    <div className="flex items-center gap-1">
    <input
  type="number"
  min="0"
  step="0.01"
  data-row={index}
  data-field="tplPrice"
  value={editingCell && editingCell.row === index && editingCell.type === 'tpl' ? 
    (editingCellValue === '0' || editingCellValue === 0 ? '' : editingCellValue) : 
    (acc.tplPrice === '0' || acc.tplPrice === 0 || !acc.tplPrice ? '' : String(Number(acc.tplPrice)))
  }
  onChange={e => {
    if (editingCell && editingCell.row === index && editingCell.type === 'tpl') {
      setEditingCellValue(e.target.value);
    } else {
      setEditingCell({ row: index, type: 'tpl' });
      setEditingCellValue(e.target.value);
    }
  }}
  onFocus={() => {
    setEditingCell({ row: index, type: 'tpl' });
    setEditingCellValue(acc.tplPrice !== undefined && acc.tplPrice !== null ? String(Number(acc.tplPrice)) : '');
    if (acc.tplTaxIncluded && taxToggledBeforeInput[`${index}-tpl`] === true) {
      // Do nothing
    } else {
      setTaxToggledBeforeInput(prev => ({ ...prev, [`${index}-tpl`]: false }));
    }
  }}
  onBlur={() => {
    if (editingCell && editingCell.row === index && editingCell.type === 'tpl') {
      if (acc.tplTaxIncluded && taxToggledBeforeInput[`${index}-tpl`]) {
        const val = parseFloat(editingCellValue) || 0;
        const taxPercentage = getTaxPercentage();
        acc.tplBase = val / (1 + taxPercentage / 100);
        acc.tplPrice = val.toFixed(2);
      } else {
        handleTplPriceChange(index, editingCellValue);
      }
      setEditingCell(null);
      setEditingCellValue('');
      setTaxToggledBeforeInput(prev => ({ ...prev, [`${index}-tpl`]: false }));
    }
  }}
  onKeyDown={e => {
    if (e.key === 'Enter') {
      e.target.blur();
    } else {
      handleKeyNavigation(e, index, 'tplPrice');
    }
  }}
  className="w-20 text-center border border-blue-200 rounded px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-500"
  disabled={!!acc.isApiHotel || !roomSelection.tpl}
/>
{/* Loading indicator overlay for SGL */}
  {loadingPrices[index] && roomSelection.tpl && (
    <div className="absolute inset-0 flex items-center justify-center bg-blue-50 bg-opacity-75 rounded">
      <LoadingSpinner size="w-4 h-4" />
    </div>
  )}


{hasBookingPeriods(acc, index) && roomSelection.tpl && (
  <button
    type="button"
    onClick={() => setCalendarPopupOpen({ rowIndex: index })}
    className="p-1 text-blue-500 hover:text-blue-700 transition-colors"
    title="Select booking period"
  >
    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 002 2z" />
    </svg>
  </button>
)}
</div>
    {/* Adult calculation summary directly below input */}
    {roomSelection.tpl && (!editingCell || editingCell.row !== index || editingCell.type !== 'tpl') && (

       <div className="flex justify-center items-center mt-1">
    <span className="text-xs text-black-500 whitespace-nowrap">
      ${formatCurrency(acc.tplPrice)} {/* Remove the multiplication display */}
    </span>
  </div>
      // <div className="flex justify-center items-center mt-1">
      //   <span className="text-xs text-black-500  whitespace-nowrap">
      //     {Math.ceil(numAdults / 3)}
      //   </span>
      //   <span className="mx-1 text-xs text-black-500">*</span>
      //   <span className="text-xs text-black-500  whitespace-nowrap">
      //     ${formatCurrency(acc.tplPrice)}
      //   </span>
      //   <span className="mx-1 text-xs text-black-500">=</span>
      //   <span className="text-xs text-black-500  whitespace-nowrap">
      //     ${formatCurrency(((parseFloat(acc.tplPrice) || 0) * Math.ceil(numAdults / 3)))}
      //   </span>
      // </div>
    )}
    {/* TPL With Bed/Without Bed inputs */}
    {roomSelection.tpl && (
      <div className="flex flex-row justify-center gap-1 mt-1">
        <div className="flex flex-col items-center">
          <label className="text-xs text-gray-700 mb-0.5">With Bed</label>
         <input
  type="number"
  min="0"
  step="0.01"
  data-row={index}
  data-field="tplExtra1"
  value={acc.tplExtra1 === '0' || acc.tplExtra1 === 0 ? '' : (acc.tplExtra1 || '')}
  onChange={e => {
    const updated = [...accommodations];
    updated[index].tplExtra1 = e.target.value;
    setAccommodations(updated);
  }}
  onKeyDown={e => handleKeyNavigation(e, index, 'tplExtra1')}
  className="w-10 text-center border border-blue-200 rounded px-1 py-0.5 text-xs"
  placeholder="With Bed"
  style={{ fontSize: '11px' }}
  disabled={!!acc.isApiHotel || !roomSelection.tpl}
/>
          <span className="text-[10px] text-gray-600 mt-0.5">{numChildren} * {acc.tplExtra1 || 0} = {formatCurrency((parseFloat(acc.tplExtra1) || 0) * numChildren)}</span>
        </div>
        <div className="flex flex-col items-center">
          <label className="text-xs text-gray-700 mb-0.5">Without Bed</label>
         <input
  type="number"
  min="0"
  step="0.01"
  data-row={index}
  data-field="tplExtra2"
  value={acc.tplExtra2 === '0' || acc.tplExtra2 === 0 ? '' : (acc.tplExtra2 || '')}
  onChange={e => {
    const updated = [...accommodations];
    updated[index].tplExtra2 = e.target.value;
    setAccommodations(updated);
  }}
  onKeyDown={e => handleKeyNavigation(e, index, 'tplExtra2')}
  className="w-10 text-center border border-blue-200 rounded px-1 py-0.5 text-xs"
  placeholder="Without Bed"
  style={{ fontSize: '11px' }}
  disabled={!!acc.isApiHotel || !roomSelection.tpl}
/>
          <span className="text-[10px] text-gray-600 mt-0.5">{numChildren} * {acc.tplExtra2 || 0} = {formatCurrency((parseFloat(acc.tplExtra2) || 0) * numChildren)}</span>
        </div>
      </div>
    )}
  </div>
</div>
                          <label className="flex items-center ml-2 text-xs text-blue-700">
                            <input
                              type="checkbox"
                              checked={!!acc.tplTaxIncluded}
                              onChange={() => handleTplTaxToggle(index)}
                              disabled={!!acc.isApiHotel || !roomSelection.tpl}
                              className="h-4 w-4 text-blue-600 border-blue-300 rounded focus:ring-blue-500 ml-1"
                            />
                            <span className="ml-1">Tax Included</span>
                          </label>
                          {acc.tplTaxIncluded && getTaxPercentage() > 0 && (
                            <span className="ml-2 text-xs text-blue-600">(incl. {getTaxPercentage()}% tax)</span>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                  {/* Total row */}
                  <tr className="bg-blue-100 sticky bottom-0 shadow-md">
                    {/* There are now 5 columns before SGL: Day, City, Hotel, Room Category, Basis */}
                    <td colSpan="5" className="border border-blue-200 p-3 text-blue-800 text-center font-semibold">
                      Total
                      <button
                        type="button"
                        className="ml-2 text-xs text-blue-600 underline hover:text-blue-800 focus:outline-none"
                        onClick={() => setTotalsExpanded(e => !e)}
                      >
                        {totalsExpanded ? 'Hide Breakdown' : 'Show Breakdown'}
                      </button>
                    </td>
                    <td className="border border-blue-200 p-3 text-blue-800 text-right font-semibold">
  $ {formatCurrency(calculateTotals().sglTotal + withBedTotals.sgl + withoutBedTotals.sgl)}
</td>
<td className="border border-blue-200 p-3 text-blue-800 text-right font-semibold">
  $ {formatCurrency(calculateTotals().dblTotal + withBedTotals.dbl + withoutBedTotals.dbl)}
</td>
<td className="border border-blue-200 p-3 text-blue-800 text-right font-semibold">
  $ {formatCurrency(calculateTotals().tplTotal + withBedTotals.tpl + withoutBedTotals.tpl)}
</td>
                  </tr>
                  {/* Expandable breakdown rows */}
                  {totalsExpanded && (
                    <>
                      <tr className="bg-blue-50">
                        <td colSpan="5" className="border border-blue-200 p-2 text-blue-700 text-right font-medium">Adult Total</td>
                        <td className="border border-blue-200 p-2 text-blue-800 text-right">{roomSelection.sgl ? `$ ${formatCurrency(calculateTotals().sglTotal)}` : '-'}</td>
                        <td className="border border-blue-200 p-2 text-blue-800 text-right">{roomSelection.dbl ? `$ ${formatCurrency(calculateTotals().dblTotal)}` : '-'}</td>
                        <td className="border border-blue-200 p-2 text-blue-800 text-right">{roomSelection.tpl ? `$ ${formatCurrency(calculateTotals().tplTotal)}` : '-'}</td>
                      </tr>
                      <tr className="bg-blue-50">
                        <td colSpan="5" className="border border-blue-200 p-2 text-blue-700 text-right font-medium">With Bed Total</td>
                        <td className="border border-blue-200 p-2 text-blue-800 text-right">{roomSelection.sgl ? `$ ${formatCurrency(withBedTotals.sgl)}` : '-'}</td>
                        <td className="border border-blue-200 p-2 text-blue-800 text-right">{roomSelection.dbl ? `$ ${formatCurrency(withBedTotals.dbl)}` : '-'}</td>
                        <td className="border border-blue-200 p-2 text-blue-800 text-right">{roomSelection.tpl ? `$ ${formatCurrency(withBedTotals.tpl)}` : '-'}</td>
                      </tr>
                      <tr className="bg-blue-50">
                        <td colSpan="5" className="border border-blue-200 p-2 text-blue-700 text-right font-medium">Without Bed Total</td>
                        <td className="border border-blue-200 p-2 text-blue-800 text-right">{roomSelection.sgl ? `$ ${formatCurrency(withoutBedTotals.sgl)}` : '-'}</td>
                        <td className="border border-blue-200 p-2 text-blue-800 text-right">{roomSelection.dbl ? `$ ${formatCurrency(withoutBedTotals.dbl)}` : '-'}</td>
                        <td className="border border-blue-200 p-2 text-blue-800 text-right">{roomSelection.tpl ? `$ ${formatCurrency(withoutBedTotals.tpl)}` : '-'}</td>
                      </tr>
                    </>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          </div>
        )}
        {/* Save and Cancel buttons - fixed at bottom */}
        <div className="p-4 border-t border-blue-200 flex justify-end space-x-3 bg-white sticky bottom-0 shadow-md z-10">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-blue-300 text-blue-600 rounded hover:bg-blue-50 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            Cancel
          </button>
          <button
            onClick={saveChanges}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
   
  );
};

export default AccommodationPopup;